export const subtitles = {
    "1": {
        "startTime": 17.0,
        "endTime": 24.05,
        "transcript": "Tauna-gguq tekitaqan allaneq qanemciluni-llu taumek yuunrirniluku nani tayim' yaaqvani nunani",
        "translation": "They say that when that guest arrived and told a story that someone from a far away village somewhere had passed away"
    },
    "2": {
        "startTime": 24.52,
        "endTime": 31.0,
        "transcript": "Nunat-gguq taukut qiatullruat, nepliatullruat.",
        "translation": "They said that that village would mourn with loud wails over him."
    },
    "3": {
        "startTime": 31.575,
        "endTime": 35.475,
        "transcript": "Waten-llu ciin qanerta, maa-i elitaq'la'rqa:",
        "translation": "I wonder why he said this, and I recognize it now:"
    },
    "4": {
        "startTime": 35.58,
        "endTime": 42.91,
        "transcript": "\"Atataarqu-gguq ella piunrirniaraqan yuum kanvellra cukariciquq.",
        "translation": "\"Later, when the world is going to end, people will die off more quickly."
    },
    "5": {
        "startTime": 44.9,
        "endTime": 49.55,
        "transcript": "\"Cali-llu-gguq ellinek, ellmeggnun akngirtaarutengluteng.\"",
        "translation": "\"They will also start hurting themselves.\""
    },
    "6": {
        "startTime": 50.97,
        "endTime": 57.29,
        "transcript": "Tuaten-llu-gguq pinanrirciqaat neplialuku, temcikluku tau͡gaam.",
        "translation": "And he said that they will no longer mourn loudly anymore, but laugh at them instead."
    },
    "7": {
        "startTime": 58.125,
        "endTime": 65.325,
        "transcript": "Tuani-gguq ellam piunrillra mallgikan yugni ayuqliulluta usviiruciiqukut.",
        "translation": "They said that when the world is close to ending, we people will all become foolish."
    },
    "8": {
        "startTime": 65.62,
        "endTime": 69.7,
        "transcript": "Man'a niitelallruaqa. Maa-i piciuyugnarquq. Elitaq'la'rqa.",
        "translation": "I used to hear this. It's probably true. I recognize it."
    },
    "9": {
        "startTime": 69.705,
        "endTime": 73.415,
        "transcript": "Yaantarcelluku niitelallemni ircaqrualallruunga.",
        "translation": "When I used to hear of it far off [in the future], my heart would skip a beat."
    },
    "10": {
        "startTime": 73.415,
        "endTime": 80.285,
        "transcript": "Wiinga-ll' tamakuni picurlagalriani arcaqanrulua man'a taangaq aturluku.",
        "translation": "And I am worse than those who do wrong, by abusing alcohol."
    },
    "11": {
        "startTime": 81.225,
        "endTime": 87.615,
        "transcript": "Taangaq atullruaqa cakneq, yuilqumek-llu tekicarturqama kiingan-llu umyuaqluku.",
        "translation": "I heavily abused alcohol, and it would be the only thing on my mind when I was coming back from the wilderness."
    },
    "12": {
        "startTime": 88.275,
        "endTime": 94.315,
        "transcript": "Maaten tang piunga una temlle'rqa wangnek navguallinikeka.",
        "translation": "I realized that I was destroying my precious body of my own accord."
    },
    "13": {
        "startTime": 95.31,
        "endTime": 101.98,
        "transcript": "Ciinllugguaratka-ll' maa-i cali mat'um nalliini ukut irniama takuatni tuaten tamana-ll' atulalqa.",
        "translation": "And my regret to this day is that I used to do that in front of my children here."
    },
    "14": {
        "startTime": 101.98,
        "endTime": 104.44,
        "transcript": "Wiinga elitnaullrullinianka.",
        "translation": "I taught them [to do that]."
    },
    "15": {
        "startTime": 104.445,
        "endTime": 108.885,
        "transcript": "Uum nalliini ciinllugguaratka tamatumek arcaqertuq.",
        "translation": "That is my greatest regret today."
    },
    "16": {
        "startTime": 113.12,
        "endTime": 115.69,
        "transcript": "Iluteqaqlua-llu",
        "translation": "And I am heartbroken"
    },
    "17": {
        "startTime": 118.08,
        "endTime": 124.52,
        "transcript": "Atawaunrilngurmek elitnaullrulliniamki wiinga wangnek navguutekamnek waten elliquma.",
        "translation": "Because I taught them this detrimental thing that would destroy me when I reached this age."
    },
    "18": {
        "startTime": 125.475,
        "endTime": 130.855,
        "transcript": "Ilumun-ll' au͡gkut yullret qanellrat-lli piciulallinivaa.",
        "translation": "Indeed, what those people said back then is quite true."
    },
    "19": {
        "startTime": 152.79,
        "endTime": 164.17,
        "transcript": "Kinguqliput-gguq kinguqlirkait nunam maani qaingani yuum ayuqucirkaanek ayagniriciqut.",
        "translation": "They said that the descendants of our descendants will establish what people will be like on this earth."
    },
    "20": {
        "startTime": 164.585,
        "endTime": 167.455,
        "transcript": "Ayagniriciqut.",
        "translation": "They will establish it."
    },
    "21": {
        "startTime": 168.065,
        "endTime": 172.245,
        "transcript": "Nutaan-llu-gguq tua-i kinguqliit ukegkut",
        "translation": "Then they said that their descendants"
    },
    "22": {
        "startTime": 172.449,
        "endTime": 184.774,
        "transcript": "Tua-i imutun tuar tang imna man'a maa-i mat'un nalliini yuut atungekiit man'a.",
        "translation": "It seems that people are starting to do this these days."
    },
    "23": {
        "startTime": 185.555,
        "endTime": 189.643,
        "transcript": "Tangvagluku tuar qalartelallrulriit.",
        "translation": "It seems they spoke watching [the future]."
    },
    "24": {
        "startTime": 189.656,
        "endTime": 194.506,
        "transcript": "Maaten waniwa waten elliama umyuaqnaunka.",
        "translation": "It turned out that when I reached this age, I would remember them."
    },
    "25": {
        "startTime": 194.513,
        "endTime": 202.163,
        "transcript": "Tuar im' tangvagluki nunat makut yugkait qanerutkelallrukiit.",
        "translation": "It seemed that they spoke of it watching the future people of these lands."
    },
    "26": {
        "startTime": 202.445,
        "endTime": 210.457,
        "transcript": "Akleng-gguq, tamana-gguq tekiskunegteggu tuaten ellillerkarteng",
        "translation": "Pity, they said, when they reach that point where they will become like that"
    },
    "27": {
        "startTime": 210.62,
        "endTime": 217.92,
        "transcript": "Imutun makut-ll' ayagyuarut qimugkara'urlurtun ellirciqut.",
        "translation": "Even their young people will become like puppies."
    },
    "28": {
        "startTime": 218.164,
        "endTime": 220.014,
        "transcript": "Tangrriu.",
        "translation": "You see?"
    },
    "29": {
        "startTime": 220.033,
        "endTime": 225.583,
        "transcript": "Maa-i taringutkeqapiaralaranka.",
        "translation": "Now, I fully understand them."
    },
    "30": {
        "startTime": 225.59,
        "endTime": 233.69,
        "transcript": "Au͡gkut yuut tuar tang imna man'a tua-i tangvakapiarluku qanrutkelallrukiit.",
        "translation": "It seemed that the people back then truly watched this time as they spoke of it."
    },
    "31": {
        "startTime": 233.834,
        "endTime": 241.684,
        "transcript": "Aling aren, maa-i-ll' tua-i teklilluku yuut makut, nunat yuita tamarmeng.",
        "translation": "Oh my goodness, and people have reached that point, every person from the lands."
    },
    "32": {
        "startTime": 241.691,
        "endTime": 246.753,
        "transcript": "Naliat-llu pinritevkenani, nunat tamarmeng tekilluku.",
        "translation": "And without leaving any out, all of the lands have come to that point."
    },
    "33": {
        "startTime": 247.191,
        "endTime": 257.029,
        "transcript": "Tua-i-gguq tuaten ellirarkaut makut ayagyuat qanruyut'seng man'a cakenriqunegteggu.",
        "translation": "They said they will definitely become like that when young people depreciate their traditional wisdom."
    },
    "34": {
        "startTime": 280.954,
        "endTime": 291.554,
        "transcript": "Tamaa-i yuilqumi anglillruama tua-i ca tamalkuan nertullruaqa naugaara'rqan up'nerkami aquingarcama.",
        "translation": "Because I grew up in the wilderness back then, I would eat everything when it started to grow in the spring when I started playing outside."
    },
    "35": {
        "startTime": 291.573,
        "endTime": 295.923,
        "transcript": "Egmianun tua-i aquingarcama cungakviit-ll' aciit nerluki.",
        "translation": "RIght when I started playing outside, I would eat [?cungakvak] roots."
    },
    "36": {
        "startTime": 295.93,
        "endTime": 300.892,
        "transcript": "Wii kasngukevkenaki irniamnun-llu qanengssak'laranka makut.",
        "translation": "I am not ashamed, and even tell these to my children."
    },
    "37": {
        "startTime": 300.905,
        "endTime": 305.718,
        "transcript": "Taug͡aam kiingan tua-i uquutvaguaq kiingan nerellrunritaqa.",
        "translation": "But the only thing I didn't eat was poison water hemlock."
    },
    "38": {
        "startTime": 305.73,
        "endTime": 308.63,
        "transcript": "Napat-llu cuyait neqnikluki.",
        "translation": "And I found tree leaves tasty."
    },
    "39": {
        "startTime": 308.649,
        "endTime": 316.312,
        "transcript": "Maaten tang taqnerurtua taqsuqsuunii. Waniwa tang taqsuqeqaqsailngua.",
        "translation": "When I became an adult, I found that I wouldn't get tired. I've never been tired, you see."
    },
    "40": {
        "startTime": 316.449,
        "endTime": 322.862,
        "transcript": "Taqsuqlua wiinga piksaitua, aqvaqullemnek tau͡gaam anerteqsaaglua pitulua.",
        "translation": "I haven't been tired, but I get short of breath when I run."
    },
    "41": {
        "startTime": 322.874,
        "endTime": 330.624,
        "transcript": "Cali-llu maaten caliyaurtua taqsuqningraata ilanka waniw' taqsuqeksaitua.",
        "translation": "And when I started working, I found that though my peers said they were tired, I haven't been tired."
    },
    "42": {
        "startTime": 330.63,
        "endTime": 333.293,
        "transcript": "Cali qerrutessiyaayuunii.",
        "translation": "And I don't get cold often."
    },
    "43": {
        "startTime": 333.305,
        "endTime": 340.73,
        "transcript": "Ilanka-ll' maqaqpiangraata maqaqsuunii. Tang tua-i maqaqsuunii maaten angliunga.",
        "translation": "And though my peers dressed very wamrly, I didn't dress warmly. I grew up without dressing warmly."
    },
    "44": {
        "startTime": 340.749,
        "endTime": 345.874,
        "transcript": "Mom-ama-ll' maqarqessaagyaaqviminek taqtullruanga.",
        "translation": "And my mom would stop after trying to have me dress warmly."
    },
    "45": {
        "startTime": 346.78,
        "endTime": 355.655,
        "transcript": "Ilumun makut naumalriit tememun ikayuutngulliniut.",
        "translation": "These plants are truly beneficial for the body."
    },
    "46": {
        "startTime": 377.886,
        "endTime": 386.986,
        "transcript": "Elluarrluten yuungnaqsukuvet elpenek ataneqerkaunrituten",
        "translation": "If you want to live right, you must not preside over yourself"
    },
    "47": {
        "startTime": 387.318,
        "endTime": 400.155,
        "transcript": "Temirtenǵurrluten-llu tuaten yuunge'rpet umyuangqerrarkauguten, umyuarteqarkauguten camek ukvermek.",
        "translation": "And even though you live as an adult like that, you must be mindful, you must think of some belief."
    },
    "48": {
        "startTime": 401.505,
        "endTime": 407.955,
        "transcript": "Agayutem pisqutiinek ukvengqerrnarqaaten.",
        "translation": "You must believe in God's will."
    },
    "49": {
        "startTime": 409.049,
        "endTime": 421.974,
        "transcript": "Tua-llu pisciigalkuvgu tauna, Yupiim alerqutiinek call' ukvengqerrnarqaaten.",
        "translation": "Then if you can't do that, you must believe in traditional Yup'ik instruction."
    },
    "50": {
        "startTime": 422.768,
        "endTime": 434.955,
        "transcript": "Tua-i-wa kiirrarpenek tuaten ukverraunek, puqigyukluten elpenek, elpenek pirpakluten yuukuvet",
        "translation": "If you live life all by yourself without any form of faith, thinking that you're smart, prideful of yourself"
    },
    "51": {
        "startTime": 435.405,
        "endTime": 439.855,
        "transcript": "Nalluaqa qaillun tayim' ayuqellerkan.",
        "translation": "I don't know how you'll end up."
    },
    "52": {
        "startTime": 461.999,
        "endTime": 476.299,
        "transcript": "Una qaneryaraq Agayutem yugnek tamaitnek, nunam mat'um yuinek aulukician ayuqucia.",
        "translation": "This traditional wisdom is how God takes care of all people, all people on this earth."
    },
    "53": {
        "startTime": 477.368,
        "endTime": 485.943,
        "transcript": "Anirtima ellarrlupiarqan ellakegtaarauluku ellarrlugniaqaat",
        "translation": "So that's why when the weather is bad, they say that the weather is bad when it's good"
    },
    "54": {
        "startTime": 485.962,
        "endTime": 491.187,
        "transcript": "Waten cunawa ellarrlitullinian:",
        "translation": "Because apparently, this is what bad weather is like:"
    },
    "55": {
        "startTime": 496.856,
        "endTime": 501.631,
        "transcript": "Ellallirnanrirluni ellarrlutullinian",
        "translation": "Because it's bad weather when it stops raining"
    },
    "56": {
        "startTime": 501.65,
        "endTime": 509.412,
        "transcript": "Cat tamarmeng naunraat-llu elluarrluki naunanrirtelluki.",
        "translation": "Stopping everything, including plants, from growing well."
    },
    "57": {
        "startTime": 509.413,
        "endTime": 521.85,
        "transcript": "Ellallirnanrirluni taicirnanrirluni-llu pitullinian, nuna man'a meculirnanrirluku.",
        "translation": "Because it stops raining and getting foggy, keeping moistrure from the land here."
    },
    "58": {
        "startTime": 522.713,
        "endTime": 537.563,
        "transcript": "Ukut wani, tua-ll' ukut wani Kass'at ukut wani waniwa ellarrluucaraqelliniat una waniwa ukut naucetaanek neqelget.",
        "translation": "Then, this is also considered bad weather for the West, these people who eat crops."
    },
    "59": {
        "startTime": 538.17,
        "endTime": 550.42,
        "transcript": "Maa-i mat'um ciungani niitelaraput naucetaarit naussiyaanritaqata kailarniluki",
        "translation": "Before this, we hear that they have a famine when their crops don't grow well"
    },
    "60": {
        "startTime": 550.427,
        "endTime": 554.789,
        "transcript": "Amlleret-llu tuquluteng paluluteng.",
        "translation": "And many starve to death."
    },
    "61": {
        "startTime": 556.315,
        "endTime": 562.227,
        "transcript": "Iliini-llu niitaqluta mermek enuqlitellrianek.",
        "translation": "And sometimes, we hear about people having water shortages."
    },
    "62": {
        "startTime": 565.778,
        "endTime": 570.965,
        "transcript": "Tamaa-i Agayutem aulukician ayuqucia.",
        "translation": "That is how God takes care of us."
    },
    "63": {
        "startTime": 573.54,
        "endTime": 581.54,
        "transcript": "Imkut-llu ciulirneret qantullruut, ca-gguq man'a",
        "translation": "And those elders used to say that something here"
    },
    "64": {
        "startTime": 592.622,
        "endTime": 600.247,
        "transcript": "Waten anirtima-llu can'giirraungraata enurnarinilarait.",
        "translation": "And it's no wonder that they say that even blackfish become scarce like this."
    },
    "65": {
        "startTime": 600.253,
        "endTime": 612.178,
        "transcript": "Waten cunawa Agayutem yun'i makut ayuqucia tangerrluku cangayagutaqamiki pilallinii.",
        "translation": "It turns out that God does this when he looks at people's behavior and disapproves."
    },
    "66": {
        "startTime": 612.247,
        "endTime": 620.822,
        "transcript": "Waten pilallinii ayuquciat tangerrluku usviirupakarqata",
        "translation": "He apprently does that depending on their behav ior when they become too foolish"
    },
    "67": {
        "startTime": 621.153,
        "endTime": 625.528,
        "transcript": "Ayuquciat elpekesqelluku.",
        "translation": "So that they will realize their wrong behavior."
    },
    "68": {
        "startTime": 646.534,
        "endTime": 653.809,
        "transcript": "Ukut naucetaanek neqelget, naucetaaritgun piitnarluki",
        "translation": "He causes those who eat crops to have a shortage of crops"
    },
    "69": {
        "startTime": 653.815,
        "endTime": 660.565,
        "transcript": "Ukut-llu kuigmek neqelget, kuigteggun piitnarluki.",
        "translation": "And those who eat from rivers to have a shortage of river [animals]."
    },
    "70": {
        "startTime": 661.447,
        "endTime": 674.834,
        "transcript": "Nallunritukut nunam qaingani naunraat naulauciat nenglem puqlam-llu akuliignegun.",
        "translation": "We know that plants grow on the earth between cold and hot temperatures."
    },
    "71": {
        "startTime": 675.059,
        "endTime": 683.897,
        "transcript": "Aipaan elluarrluki nauvkarngaunaki pitatekenrilkagnek.",
        "translation": "The other will keep them from growing well if they are not in harmony."
    },
    "72": {
        "startTime": 685.072,
        "endTime": 690.997,
        "transcript": "Tuaten-llu mermiutaat neqet ayuqut.",
        "translation": "Our food sources from the water are also like that."
    },
    "73": {
        "startTime": 691.216,
        "endTime": 702.716,
        "transcript": "Kumlam puqlam-llu akuliignegun ellaita ellarrameggni ayuqngat'lalliniut.",
        "translation": "It seems they are also between cold and hot in their little environments."
    },
    "74": {
        "startTime": 703.335,
        "endTime": 710.435,
        "transcript": "Tamatum ellarrluum piitnam nallunairaa.",
        "translation": "That bad weather that brings about famine shows that."
    },
    "75": {
        "startTime": 710.667,
        "endTime": 714.204,
        "transcript": "Ava-i qanrutkaa.",
        "translation": "It shows that."
    },
    "76": {
        "startTime": 714.217,
        "endTime": 723.329,
        "transcript": "Anirtima-llu can'giirraungraata enurnarinilarait piitnam nalliini.",
        "translation": "So that's why they say even little blackfish become scarce during a famine."
    },
    "77": {
        "startTime": 724.605,
        "endTime": 733.417,
        "transcript": "Piitnaq qanrutkestain qanrutketuat.",
        "translation": "Those that show the signs of famine, show the signs."
    },
    "78": {
        "startTime": 756.78,
        "endTime": 760.118,
        "transcript": "Piitnaq-gguq malruuguq.",
        "translation": "They say there are two types of famine."
    },
    "79": {
        "startTime": 760.918,
        "endTime": 768.381,
        "transcript": "Aipaa angucaluuluni, aipaa-llu arnacaluuluni.",
        "translation": "The other is a male, and the other is a female."
    },
    "80": {
        "startTime": 768.643,
        "endTime": 773.518,
        "transcript": "Angucaluq-gguq kiagnaciatunruuq.",
        "translation": "They say in the male, summer comes later."
    },
    "81": {
        "startTime": 776.687,
        "endTime": 781.499,
        "transcript": "Arnacaluq-gguq tau͡gken kiagyaratunruluni.",
        "translation": "They say, however, that in the female, summer comes earlier."
    },
    "82": {
        "startTime": 781.812,
        "endTime": 789.787,
        "transcript": "Ellarrlutuuq-gguq ella iluarrluku, nunat qavcin aturpek'naku.",
        "translation": "They say bad weather happens in all of the world, not just experienced by a few lands."
    },
    "83": {
        "startTime": 790.031,
        "endTime": 794.868,
        "transcript": "Tau͡gaam nunat tamarmeng atutuat.",
        "translation": "Instead, all lands experience it."
    },
    "84": {
        "startTime": 796.368,
        "endTime": 804.793,
        "transcript": "Una tunglirput atullrat arnacaluuningatetullruat.",
        "translation": "I think they'd say that the one of our time was a female one."
    },
    "85": {
        "startTime": 804.812,
        "endTime": 811.374,
        "transcript": "Tua-lli-wa yuk amlleq palullrullinilria",
        "translation": "Also, many people starved to death"
    },
    "86": {
        "startTime": 811.937,
        "endTime": 816.25,
        "transcript": "Nunat-llu ilait nunaunriraluteng.",
        "translation": "And some villages became ghost towns."
    },
    "87": {
        "startTime": 817.312,
        "endTime": 830.887,
        "transcript": "Taumek yuut tayima yuut nangqapigtenrilnge'rmeng unguvaqalriit nugtartelallilriit.",
        "translation": "That's probably why people, even if it's not every last person, the ones who are alive relocate."
    },
    "88": {
        "startTime": 830.981,
        "endTime": 835.168,
        "transcript": "Ciumek-llu-gguq qimugcaircatuuq.",
        "translation": "They also said that the dogs die off first."
    },
    "89": {
        "startTime": 837.031,
        "endTime": 841.143,
        "transcript": "Nunat ilait avullugtengluteng.",
        "translation": "Some villages start having bad people."
    },
    "90": {
        "startTime": 842.519,
        "endTime": 854.194,
        "transcript": "Cali-llu-gguq ellarrlugarkaurtaqan erenret iquatni agya aruvilangetuuq.",
        "translation": "They also said that when bad weather is nigh, the starts at the end of the night become smoky."
    },
    "91": {
        "startTime": 854.475,
        "endTime": 859.488,
        "transcript": "Cali-llu-gguq ella-gguq quptuuq.",
        "translation": "They also said that the world would “crack.\""
    },
    "92": {
        "startTime": 859.5,
        "endTime": 869.375,
        "transcript": "Qiaryaarluni-gguq quptuuq, avatek-gguq kegglaperyayagarlutek.",
        "translation": "They said that it crackles as it \"cracks,\" with the side areas having saw-like teeth."
    },
    "93": {
        "startTime": 870.506,
        "endTime": 877.831,
        "transcript": "Tamaa-i-gguq ellakun palullret uyanglluteng.",
        "translation": "They say that the people who starved are looking down."
    },
    "94": {
        "startTime": 879.187,
        "endTime": 884.925,
        "transcript": "Yuut-llu-gguq amlleret elpektuat qup'aqan",
        "translation": "They also say that many people notice when it cracks."
    },
    "95": {
        "startTime": 885.8,
        "endTime": 892.25,
        "transcript": "Tang makut nallunailkutauluki qanrutkelallrit.",
        "translation": "You see, these are the signs that they spoke about."
    },
    "96": {
        "startTime": 917.657,
        "endTime": 930.069,
        "transcript": "Qantuut-gguq atam-gguq ellarrluk canimellikan",
        "translation": "They say that when bad weather is getting close"
    },
    "97": {
        "startTime": 930.082,
        "endTime": 941.457,
        "transcript": "Qanelriartairutniartuq kaigyaram ayuqucianek, ilacingluteng.",
        "translation": "There'll be no more people talking about what famine is like, and they will sit and wait for others to work for them."
    },
    "98": {
        "startTime": 942.188,
        "endTime": 952.213,
        "transcript": "Wangkuta-llu anguvilqautellerni niitelallerput qanruteksuilamteki",
        "translation": "Also, because we who were born in time to see them do not speak about what we used to hear"
    },
    "99": {
        "startTime": 953.144,
        "endTime": 958.844,
        "transcript": "Bible-aani Paul-aam qanellruciatun.",
        "translation": "As Paul said in the Bible."
    },
    "100": {
        "startTime": 959.538,
        "endTime": 967.963,
        "transcript": "Ciulirnernek-llu camek unangellrunritua. Ciulirneruyaaqellilriit.",
        "translation": "And I didn't receive anything from the ancestors. They're probably ancestors."
    },
    "101": {
        "startTime": 969.494,
        "endTime": 980.144,
        "transcript": "Wangkuta anguvilqautellerni qanlallrita tungiitnun qerrluugarkauyaaqukut",
        "translation": "We who were born in time to see them must be the mouths for what they said"
    },
    "102": {
        "startTime": 980.288,
        "endTime": 987.326,
        "transcript": "Qanlallrita makut ayagyuat tungiitnun.",
        "translation": "What they used to say about these young people."
    },
    "103": {
        "startTime": 987.839,
        "endTime": 1000.014,
        "transcript": "Without having heard what that's like, how will the people who reach that time use the traditional instructions concerning it?",
        "translation": "Without having heard what that's like, how will the people who reach that time use the traditional instructions concerning it?"
    },
    "104": {
        "startTime": 1004.395,
        "endTime": 1013.745,
        "transcript": "Qanrutketuat ellarrlukatangraan-gguq neqaitqapigcuicaaquq.",
        "translation": "They say that though bad weather is nigh, there isn't a complete lack of food sources."
    },
    "105": {
        "startTime": 1014.164,
        "endTime": 1019.777,
        "transcript": "Tau͡gaam-gguq neqait cukangatetuut.",
        "translation": "But they said that their food sources seem to [deplete] quickly."
    },
    "106": {
        "startTime": 1020.864,
        "endTime": 1028.389,
        "transcript": "Tayima-llu uksuq qaillun ellirluku pircirturangetua?",
        "translation": "And at what point in the winter do blizzards become frequent?"
    },
    "107": {
        "startTime": 1030.158,
        "endTime": 1036.795,
        "transcript": "Ella-gguq assiyuituq pircirrlainarluni.",
        "translation": "They say the weather isn't good, with blizzards happening all the time."
    },
    "108": {
        "startTime": 1037.47,
        "endTime": 1043.908,
        "transcript": "Nani-llu yuk tumkeliluni ayayuunani.",
        "translation": "And a person does not travel anywhere with good paths."
    },
    "109": {
        "startTime": 1044.558,
        "endTime": 1058.471,
        "transcript": "Iliini ertekegtaararraarluni erneq iquklicugnaunaku anuqni uivqerrluku ellaqertetuluni.",
        "translation": "Sometimes, after dawn breaks on a wonderful day, the wind shifts and the weather turns bad long before the day is over."
    },
    "110": {
        "startTime": 1059.683,
        "endTime": 1069.196,
        "transcript": "Angutet-llu angungnaquralriit elluarrluteng angungnaqu'urciiganateng.",
        "translation": "And the men who subsist cannot subsist well."
    },
    "111": {
        "startTime": 1070.208,
        "endTime": 1084.646,
        "transcript": "Cali-llu can'giircuutet taluyat kanermek imangqetuniluki.",
        "translation": "They also say that blackfish traps are filled with frost."
    },
    "112": {
        "startTime": 1085.134,
        "endTime": 1090.146,
        "transcript": "Nugtaqaiceteng avirlurtaqluteng.",
        "translation": "When they take them out of the water, they clang."
    },
    "113": {
        "startTime": 1090.397,
        "endTime": 1096.172,
        "transcript": "Kaneq taluyat iluatni avirlurrluni.",
        "translation": "The frost in the fish traps clang."
    },
    "114": {
        "startTime": 1096.391,
        "endTime": 1105.203,
        "transcript": "Iliini kanrem akuliini can'giiq atauciq tangrruugaqluni.",
        "translation": "Sometimes, there is one blackfish visible among the frost."
    },
    "115": {
        "startTime": 1106.729,
        "endTime": 1117.954,
        "transcript": "Tamaa-i mer'em mermi kumlam nall'aringalallii.",
        "translation": "There in the water, the cold may be coming into contact with them."
    },
    "116": {
        "startTime": 1118.473,
        "endTime": 1128.235,
        "transcript": "Mat'um nalliini carvaneq kanermek ilangqessuituq.",
        "translation": "These days, there is no frost in the currents."
    },
    "117": {
        "startTime": 1132.273,
        "endTime": 1141.523,
        "transcript": "Piitnam nalliini carvaneq kanermek ilangerrngatetulliniuq.",
        "translation": "There seems to be frost in the currents during famines."
    },
    "118": {
        "startTime": 1163.167,
        "endTime": 1167.73,
        "transcript": "Can'giiq tau͡gaam ut'rulluku.",
        "translation": "Instead, he brought home a blackfish"
    },
    "119": {
        "startTime": 1170.492,
        "endTime": 1179.892,
        "transcript": "Tekiucaku-llu egan mermek imirluku kuimarcetaarluku",
        "translation": "Then when he brought it home, he filled a pot with water to try to have it swim"
    },
    "120": {
        "startTime": 1180.899,
        "endTime": 1186.536,
        "transcript": "Mer'em currlungllerkaa umyuaqluku.",
        "translation": "With the mind to make the water a little cloudy."
    },
    "121": {
        "startTime": 1187.511,
        "endTime": 1201.224,
        "transcript": "Currlungan-llu kenirluku.",
        "translation": "Then when it got cloudy, he cooked it."
    },
    "122": {
        "startTime": 1209.999,
        "endTime": 1215.486,
        "transcript": "Currlungan-llu kenirluku. Ilakelriit nerluku.",
        "translation": "When it got cloudy, they cooked it. The family ate it."
    },
    "123": {
        "startTime": 1216.911,
        "endTime": 1227.061,
        "transcript": "Can'giiq atauciq itumlluku tayarunek, anllernek, quagcinek-llu ilaluku.",
        "translation": "They broke apart one blackfish and added mare's-tails, tall cottongrass tubers, and sourdock."
    },
    "124": {
        "startTime": 1227.068,
        "endTime": 1233.255,
        "transcript": "Tayaruq atauciq nertulliniat.",
        "translation": "Apparently, they would eat one mare's-tail."
    },
    "125": {
        "startTime": 1235.668,
        "endTime": 1243.618,
        "transcript": "Cali melugnek piutaitellerkarteng nangyaqluku.",
        "translation": "They were also afraid of having no fish roe."
    },
    "126": {
        "startTime": 1244.075,
        "endTime": 1252.9,
        "transcript": "Meluut kinercirat cangariyuitut ak'allaurteng'e'rmeng.",
        "translation": "Dried fish roe does not spoil no matter how old they get."
    },
    "127": {
        "startTime": 1253.056,
        "endTime": 1257.844,
        "transcript": "Tamaa-i yuurqaariluki.",
        "translation": "They made those in day old blackfish stews."
    },
    "128": {
        "startTime": 1258.144,
        "endTime": 1273.994,
        "transcript": "Cali-llu-gguq qangqiirem anaa cikaa-llu teguluku nernge'rmiu cangalliurutekngaitaa-gguq aqsaqu͡ran.",
        "translation": "They also said that even if they take solid or watery ptarmigan feces and eat it, their stomach will not be upset from it."
    },
    "129": {
        "startTime": 1274.001,
        "endTime": 1280.176,
        "transcript": "Peqliungan-gguq napanek neqengqerrata.",
        "translation": "They said it's because it's [?clean] since they eat trees."
    },
    "130": {
        "startTime": 1303.27,
        "endTime": 1320.145,
        "transcript": "Anluami wall'u qenuillermi imna alungyar can'giicuayaaq tangerqaku",
        "translation": "If one sees a blackfish fry, a small blackfish, in a fishing hole in the ice or a place where the ice was picked out"
    },
    "131": {
        "startTime": 1320.651,
        "endTime": 1328.351,
        "transcript": "Aqsaqu͡ra temingraan aglumaqaasqenritaat.",
        "translation": "Though his stomach rumbles, they say that he shouldn't covet it."
    },
    "132": {
        "startTime": 1328.758,
        "endTime": 1334.77,
        "transcript": "Ut'rulluku tau͡gaam kenirluku neresqaat.",
        "translation": "They that he should instead bring it home, cook it, and eat it."
    },
    "133": {
        "startTime": 1336.458,
        "endTime": 1346.621,
        "transcript": "Tauna-am qaneryarimaat waten, au͡gna can'giicuayaaq:",
        "translation": "They have this traditional wisdom concerning that small blackfish:"
    },
    "134": {
        "startTime": 1347.108,
        "endTime": 1360.208,
        "transcript": "Qassaa nerkaku, wagg'uq qumikegcilriamek iluan pitgautekarkaungaku ellminek tuqulluni.",
        "translation": "Because if he eats it raw, they say their stomach \"shoots an arrow\" at such wonderful contents, and kills himself."
    },
    "135": {
        "startTime": 1361.352,
        "endTime": 1374.602,
        "transcript": "Yuum-gguq aqsaqu͡ra uquirutaqami caqassurarangtuuq, camek-llu cikinerrlugcunaunani.",
        "translation": "They say that when a person's stomach has no more fat, it becomes volatile, and shouldn't be given anything bad."
    },
    "136": {
        "startTime": 1378.096,
        "endTime": 1386.946,
        "transcript": "Uqiqallerkaq nervallallerkaq-llu ellminek munaruqu'urluku.",
        "translation": "He should take care not to eat too much oil or fat, or eating too much."
    },
    "137": {
        "startTime": 1387.278,
        "endTime": 1398.428,
        "transcript": "Tamaani pinillrulliniut yuut mermek neqengqenritlermeggni.",
        "translation": "People were evidently strong back then when water wasn't their food source."
    },
    "138": {
        "startTime": 1399.285,
        "endTime": 1414.46,
        "transcript": "Tamakut angungnaquralriit kemgitem ugaani ayakata'arqameng tet'eng-llu kevirluki ayagaqluteng",
        "translation": "Because those who were subsisting were so skinny, they would stuff their anuses when they were going to travel"
    },
    "139": {
        "startTime": 1414.466,
        "endTime": 1420.741,
        "transcript": "Anuqem iteryulaaki ugaani kemgitem.",
        "translation": "Because they get drafty since they're so skinny."
    },
    "140": {
        "startTime": 1453.872,
        "endTime": 1461.672,
        "transcript": "Aarnarqelria man'a kiak maa-i-am tua-i alairtuq.",
        "translation": "This dangerous summer has appeared now."
    },
    "141": {
        "startTime": 1461.679,
        "endTime": 1465.604,
        "transcript": "Merkun-llu cali maa-i tarratengluta cali.",
        "translation": "We also wander through the water now."
    },
    "142": {
        "startTime": 1466.548,
        "endTime": 1476.11,
        "transcript": "Mat'um taangam waniwa picurlagatngucia",
        "translation": "This misfortune that alcohol brings"
    },
    "143": {
        "startTime": 1476.623,
        "endTime": 1484.136,
        "transcript": "Cali-llu yuum wani navguutngucia",
        "translation": "And how it destroys people"
    },
    "144": {
        "startTime": 1484.248,
        "endTime": 1488.611,
        "transcript": "Tua-i elpeknariyaaqelria tayima.",
        "translation": "It's time we've realized this."
    },
    "145": {
        "startTime": 1488.623,
        "endTime": 1495.286,
        "transcript": "Aturtek'lallmini-llu tayima cali elpeknariyaaquq.",
        "translation": "It's also time that those who've abused it realized this."
    },
    "146": {
        "startTime": 1495.611,
        "endTime": 1505.323,
        "transcript": "Arenqiatuq tau͡gaam tua-i aturyugtain atulaamegteggu atuusqumanricaaqeng'e'rmi.",
        "translation": "But it's unfortunate that those who want to use it abuse it, though he is told not to."
    },
    "147": {
        "startTime": 1505.336,
        "endTime": 1513.499,
        "transcript": "Tua-i ellaita arcaqaqekteng atularaat.",
        "translation": "They practice what they value."
    },
    "148": {
        "startTime": 1515.036,
        "endTime": 1520.786,
        "transcript": "Maa-i mat'um nalliini yuk wani waten ayuquq:",
        "translation": "These days, a person is like this:"
    },
    "149": {
        "startTime": 1520.905,
        "endTime": 1532.305,
        "transcript": "Watua waniwa qalaruqaarluku, nangerngaluni cavkenani waniwa qalaruqaarluku",
        "translation": "After being spoken to, after he stands without doing anything as he's spoken to"
    },
    "150": {
        "startTime": 1532.324,
        "endTime": 1538.249,
        "transcript": "Tua-i-llu ayiimi mer'aluni.",
        "translation": "Then when he goes, he drinks."
    },
    "151": {
        "startTime": 1539.23,
        "endTime": 1548.768,
        "transcript": "Tayima-llu sass'aq cali naavailgan cali, ilii pivakarluni angyaminek katalartuq",
        "translation": "And before an hour is up, one falls from his boat because he [drank] too much"
    },
    "152": {
        "startTime": 1548.781,
        "endTime": 1551.706,
        "transcript": "Angyam-llu unilluku.",
        "translation": "And the boat leaves him."
    },
    "153": {
        "startTime": 1553.325,
        "endTime": 1557.5,
        "transcript": "Qaillun-llu anirtuasciiganani tauna.",
        "translation": "And he can't be saved by any means."
    },
    "154": {
        "startTime": 1557.856,
        "endTime": 1564.356,
        "transcript": "Tua-i ellminek tuqutelartuq tauna. Cakneq-lli nallunaipaa.",
        "translation": "He kills himself. That is very clear."
    },
    "155": {
        "startTime": 1565.138,
        "endTime": 1568.7,
        "transcript": "Ellminek tuqulluni.",
        "translation": "He kills himself."
    },
    "156": {
        "startTime": 1568.701,
        "endTime": 1584.413,
        "transcript": "Tua-i tuarpiaq imutun cangallruvkenani ellminek nutellriami, wall'u nuusimek ellminek kapellriami, wall'u qemitellriami-llu.",
        "translation": "It truly seems that it is no different from shooting oneself, or stabbing oneself with a knife, or hanging oneself."
    },
    "157": {
        "startTime": 1584.433,
        "endTime": 1588.72,
        "transcript": "Tua-i cangallruvkenani.",
        "translation": "It's no different."
    },
    "158": {
        "startTime": 1590.195,
        "endTime": 1597.008,
        "transcript": "Mermun igtaqami tua-i ellminek tuqutelartuq.",
        "translation": "When he falls into the water [drunk], he kills himself."
    },
    "159": {
        "startTime": 1597.308,
        "endTime": 1601.345,
        "transcript": "Man'a taringesqumangyaaqaqa wiinga.",
        "translation": "I want people to understand this now."
    },
    "160": {
        "startTime": 1601.358,
        "endTime": 1607.995,
        "transcript": "Tua-i wiinga carrluuyaaqeng'e'rma wangnek tunullua",
        "translation": "Though I am a bad person, turn away from me"
    },
    "161": {
        "startTime": 1608.47,
        "endTime": 1614.033,
        "transcript": "Tunullua wangnek umyuaqesqumangyaaqaqa makunun",
        "translation": "I want them to turn away from me and remember this"
    },
    "162": {
        "startTime": 1614.045,
        "endTime": 1619.72,
        "transcript": "Taringesqumangyaaqluku-llu makunun ayagyuaqegtaarnun",
        "translation": "And I want these precious young people to understand it"
    },
    "163": {
        "startTime": 1620.289,
        "endTime": 1626.701,
        "transcript": "Ellaita ayuqucirteng ellmeggnek navguassiyaakaitnun.",
        "translation": "Their behaviours that make them destroy themselves."
    },
    "164": {
        "startTime": 1652.714,
        "endTime": 1665.389,
        "transcript": "Ellaita-llu ukuk wani angayuqateng, angayuqaita kenekngamegteki auluk'laryaaqait mikelnguuluki.",
        "translation": "And their parents, their parents take care of them when they're children out of love."
    },
    "165": {
        "startTime": 1665.408,
        "endTime": 1669.433,
        "transcript": "Tau͡gaam ellmeggnek nangertaqameng",
        "translation": "But when they stand by themselves"
    },
    "166": {
        "startTime": 1669.564,
        "endTime": 1680.089,
        "transcript": "Ilaita tuarpiaq imutun ellmeggnek anglilriatun ayuqluteng",
        "translation": "Some of them truly seems as if they raised themselves"
    },
    "167": {
        "startTime": 1680.12,
        "endTime": 1688.095,
        "transcript": "Angayuqateng-llu ukut-wa, ukuk wani cakevkenakek qigcikevkenakek-llu.",
        "translation": "And they disparage their parents and do not respect them."
    },
    "168": {
        "startTime": 1688.101,
        "endTime": 1694.789,
        "transcript": "Qanellrak-llu cali umyuaqsuunaku aturpek'naku-llu.",
        "translation": "They also don't remember or heed what they said."
    },
    "169": {
        "startTime": 1694.802,
        "endTime": 1707.102,
        "transcript": "Atunritlermegnegun-llu tamaaggun angayuqateng cikirtularait kiaresngiatmek",
        "translation": "And because they don't heed them, they give their parents shame"
    },
    "170": {
        "startTime": 1707.559,
        "endTime": 1711.859,
        "transcript": "Assiitqapigtellriamek tamatumek.",
        "translation": "That terrible thing."
    },
    "171": {
        "startTime": 1712.684,
        "endTime": 1724.346,
        "transcript": "Kiaresngiatevkarluki tuarpiaq iqlutun akinaurlukek ukuk wani angayuqateng.",
        "translation": "They make them ashamed, like they pay their parents back the wrong way."
    },
    "172": {
        "startTime": 1724.434,
        "endTime": 1733.947,
        "transcript": "Man'a taringengluku man'a ayuqucirteng, aturyullerteng man'a taangaq pegeskunegteggu",
        "translation": "If they understand their behavior and they give up the alcohol they are prone to abusing"
    },
    "173": {
        "startTime": 1733.959,
        "endTime": 1738.584,
        "transcript": "Cakneq-lli atawauyarpaa.",
        "translation": "That would be greatly beneficial."
    },
    "174": {
        "startTime": 1738.928,
        "endTime": 1746.003,
        "transcript": "Quyanarqeqapiarluni-llu kina imna pegcilria.",
        "translation": "And one who gives it up is cause for great thanks."
    },
    "175": {
        "startTime": 1746.122,
        "endTime": 1754.122,
        "transcript": "Makut-llu maa-i cali cuqkaularyaaqut tamakuni makuni meryulriani:",
        "translation": "These are also the examples for those who abuse alcohol:"
    },
    "176": {
        "startTime": 1754.129,
        "endTime": 1768.666,
        "transcript": "Yuum ilii wiinga tangerturallemni meryukapigtelartuq, kiituani angliuq, kiituani-llu nulirturtuq.",
        "translation": "Some people, from what I've seen, are heavily alcoholic until eventually he grows up, and he eventually takes a wife."
    },
    "177": {
        "startTime": 1769.266,
        "endTime": 1779.166,
        "transcript": "Tua-i-llu ayainanermini imna man'a ayuqucini meryullni pegtelaraa iliin.",
        "translation": "Then as they go, some of them gives up their alcoholic behavior."
    },
    "178": {
        "startTime": 1779.185,
        "endTime": 1784.06,
        "transcript": "Teguqaquvkenaki tua-i peggluku tunulluku.",
        "translation": "They don't repeatedly take it up, but give it up and turn away from it."
    },
    "179": {
        "startTime": 1784.154,
        "endTime": 1798.341,
        "transcript": "Cakneq-lli taumi tua-i qanerturanrilengramta-llu wangkuta tua-i umyuamteggun quyakeqapiarluku ayuqelartukut.",
        "translation": "Oh my goodness, even though we don't always say it, we are so thankful for them in our minds."
    },
    "180": {
        "startTime": 1798.354,
        "endTime": 1803.041,
        "transcript": "Tua-i man'a waten cali pitaqerluku cali qanrutkaqa.",
        "translation": "This is all I'm going to say about this."
    },
    "181": {
        "startTime": 1824.466,
        "endTime": 1837.104,
        "transcript": "Tamaa-i, tamaa-i tamatum nalliini ayagassuutengqertut qayanek.",
        "translation": "During that time, they traveled with kayaks."
    },
    "182": {
        "startTime": 1837.392,
        "endTime": 1850.254,
        "transcript": "Tua-llu anuqengararutaqateng qaspengqerrluteng-llu imkunek maklaaret qiluitnek",
        "translation": "Then when the wind starts blowing on them, they also had thin pullover garments made of bearded seal intestines"
    },
    "183": {
        "startTime": 1850.267,
        "endTime": 1855.555,
        "transcript": "Irnerrlugnek qaspernek all'uki pitulinek.",
        "translation": "The seal gut pullovers that they put on."
    },
    "184": {
        "startTime": 1855.668,
        "endTime": 1862.205,
        "transcript": "Tamakunek qayam una painga, iciw' uivenqellriit?",
        "translation": "With those, the kayak rims, you know how they're round?"
    },
    "185": {
        "startTime": 1862.405,
        "endTime": 1867.368,
        "transcript": "Qayanek-qaa tanglallruuten? Iciw' uivenqellriit?",
        "translation": "Did you see kayaks before? You know how they're round?"
    },
    "186": {
        "startTime": 1867.38,
        "endTime": 1872.868,
        "transcript": "Kinguqaminek qumigluku qayam painga.",
        "translation": "He puts the kayak rim inside his hem."
    },
    "187": {
        "startTime": 1872.881,
        "endTime": 1883.268,
        "transcript": "Tua-i-llu nutaan pelacinaunrilngurmek tapengyaarmek pinevkarluku piliameggnek nemerluku. Tua-i-gguq ket'garluku.",
        "translation": "Then they would bind it with something that wasn't twine, but handmade ropes of spiraled sealskin. They called that securing it with a cord, \"ket'garluku\"."
    },
    "188": {
        "startTime": 1883.281,
        "endTime": 1891.656,
        "transcript": "Tua-i qairem waten pilangraani iterciiganani qayaan iluanun.",
        "translation": "Though the waves do this to him, it can't go in his kayak."
    },
    "189": {
        "startTime": 1891.875,
        "endTime": 1896.112,
        "transcript": "Tuaten pitullruut.",
        "translation": "That's what they used to do."
    },
    "190": {
        "startTime": 1896.162,
        "endTime": 1902.087,
        "transcript": "Qayaan iluanun iterciiganani meq qumikngani.",
        "translation": "The water can't go into his kayak because he's holding it [secure] with his garment."
    },
    "191": {
        "startTime": 1902.343,
        "endTime": 1911.568,
        "transcript": "Tua-ll' makut wani angyat kill'uteng-llu piksaitelaryaaqut.",
        "translation": "Then these boats haven't sunk."
    },
    "192": {
        "startTime": 1911.749,
        "endTime": 1923.299,
        "transcript": "Tau͡gaam mat'um, mat'um aturyulallrata, atungnaq'lallrata picurlagavkalarai.",
        "translation": "But this thing that they abuse leads them to misfortune."
    },
    "193": {
        "startTime": 1923.306,
        "endTime": 1929.606,
        "transcript": "Picutlagatek'larai taangamek aterpagcimalria.",
        "translation": "What is called alcohol is what brings them to misfortune."
    },
    "194": {
        "startTime": 1929.85,
        "endTime": 1934.8,
        "transcript": "Tamakutaitellrani picurlalriartaitellruuq.",
        "translation": "When there was none of that, there was no one who got into misfortune."
    },
    "195": {
        "startTime": 1934.894,
        "endTime": 1942.782,
        "transcript": "Picurlalriamek niicuitellruukut kiagmi kit'ellriamek.",
        "translation": "We didn't hear of people getting into misfortune in the summer, those who drowned."
    },
    "196": {
        "startTime": 1942.795,
        "endTime": 1954.657,
        "transcript": "Maa-i mat'um, mat'um tua-i atuusqumanricaaqaat nunat tamarmeng yuita ayagyuat.",
        "translation": "People from every village do not want young people to abuse this [alcohol]."
    },
    "197": {
        "startTime": 1954.77,
        "endTime": 1958.358,
        "transcript": "Ayagyuanrilnge'rmeng-llu pilalriit.",
        "translation": "They also do it even if they're not young."
    },
    "198": {
        "startTime": 1958.421,
        "endTime": 1964.496,
        "transcript": "Kanevtellriatun waten, kanevtellriatun ayuqluki.",
        "translation": "It's like it makes them drop [dead]."
    },
    "199": {
        "startTime": 1964.627,
        "endTime": 1970.177,
        "transcript": "Tua-i tuaten wii ayuqekutela'arqa kanevtellriatun.",
        "translation": "That's how I compare it, like it makes from drop [dead]."
    },
    "200": {
        "startTime": 1970.196,
        "endTime": 1980.671,
        "transcript": "Iciw' kanevciaqamta tua-i kanvelalria, imna-ll' taryirissuutmek pilallerput kanvaqluni.",
        "translation": "You know when we scatter things, they drop, and what we call a salt shaker scatters [salt]."
    },
    "201": {
        "startTime": 1980.677,
        "endTime": 1994.39,
        "transcript": "Tuarpiaq umyuartequrarqama tuaten tua-i kanvutekluku man'a aturyulallrat.",
        "translation": "It truly seems that, when I think about it, what they abuse makes them drop [dead] like that."
    },
    "202": {
        "startTime": 1994.402,
        "endTime": 2000.002,
        "transcript": "Tamakut camek nallullruut tamatutaitellrani.",
        "translation": "Those people didn't know of any [misfortune] when there was none of that."
    },
    "203": {
        "startTime": 2023.521,
        "endTime": 2032.309,
        "transcript": "Waniwa tua-i tamakut pugtaucilartut yuk pugtavkarluku.",
        "translation": "Now, they have floatation devices that keep a person afloat."
    },
    "204": {
        "startTime": 2032.322,
        "endTime": 2037.334,
        "transcript": "Tamakunek piicunaunani, piicunaicaaqluni.",
        "translation": "One shouldn't be without those."
    },
    "205": {
        "startTime": 2037.847,
        "endTime": 2043.097,
        "transcript": "Uqamaitenrilata-llu ayauqurayunaqluteng.",
        "translation": "And they're easy to bring along since they're not heavy."
    },
    "206": {
        "startTime": 2045.241,
        "endTime": 2052.329,
        "transcript": "Kaigmi, kiagmi ayagauralalriit maa-i tua-i.",
        "translation": "In the summer, people always travel in the summer now."
    },
    "207": {
        "startTime": 2052.342,
        "endTime": 2058.554,
        "transcript": "Tamaani tau͡gken ciuqvani tamakutaituq kit'essuutnek.",
        "translation": "Back then, however, there were none of those for when people fall into water."
    },
    "208": {
        "startTime": 2058.567,
        "endTime": 2064.867,
        "transcript": "Angyakun-llu ayagayuunateng, qayakun tau͡gaam anguarluteng.",
        "translation": "And they wouldn't travel by boat, but row kayaks."
    },
    "209": {
        "startTime": 2065.261,
        "endTime": 2069.061,
        "transcript": "Tamaa-i ayagassuutiit qayaq.",
        "translation": "They used that kayak to travel."
    },
    "210": {
        "startTime": 2069.105,
        "endTime": 2078.83,
        "transcript": "Maa-i tau͡gken angyarluteng, levaarluteng. Qaciggluteng tua-i ayagaaqluteng.",
        "translation": "Now, however, they have boats, boat motors. They travel with ease."
    },
    "211": {
        "startTime": 2078.949,
        "endTime": 2088.524,
        "transcript": "Taumek tamakut kit'essuutet tua-i qeleksunarqut.",
        "translation": "That's why people need to keep those floatation devices."
    },
    "212": {
        "startTime": 2088.53,
        "endTime": 2099.468,
        "transcript": "Waniwa tua-i nallunritukut, nallunrirtukut yuum, yuum picurlii waniw' ciuqerrani uitauq.",
        "translation": "Now, we know, we found out that a person's [potential for] misfortune is right in front of him."
    },
    "213": {
        "startTime": 2099.593,
        "endTime": 2114.343,
        "transcript": "Iciwa waniwa-llu angnirluni engelallagalluni-llu pirraarluni, tua-i-llu ilani unicamiki tayimqerrluni.",
        "translation": "Now, you know that after a pesron is happy and laughs, then when he leaves his peers, he's gone."
    },
    "214": {
        "startTime": 2114.4,
        "endTime": 2124.2,
        "transcript": "Tang yuum picurlallran nantenrilucia. Tua-i waniw' ciuqerrani uitauq.",
        "translation": "You see, a person's [potential for] misfortune is right there. It's right in front of him."
    },
    "215": {
        "startTime": 2124.757,
        "endTime": 2139.407,
        "transcript": "Taumek alerquutet makut, makut Kass'at cait cakaarayuunaicaaqut.",
        "translation": "That's why these instructions, these Western things, should not be disregarded."
    },
    "216": {
        "startTime": 2139.414,
        "endTime": 2148.401,
        "transcript": "Tamakut-llu kit'essuutet tua-i avaqliqluki, avaqliqluki, uqamaitevkenateng-llu.",
        "translation": "That's why they should keep those floatation devices with them, and they're not heavy."
    },
    "217": {
        "startTime": 2171.851,
        "endTime": 2188.001,
        "transcript": "Ciuqliput nang'ngata, qanruyutet tamakunek ciuqlimteńek qanrutkestairucata qanrutkestairutut.",
        "translation": "Because our elders are going, beacuse no one is speaking about that traditional wisdom from our elders, no one is talking about them anymore."
    },
    "218": {
        "startTime": 2189.895,
        "endTime": 2196.195,
        "transcript": "Ilaita-llu nallunrit'laryaaqellikait tayima.",
        "translation": "Some people probably also know them."
    },
    "219": {
        "startTime": 2196.589,
        "endTime": 2203.389,
        "transcript": "Qanruyun ak'allaq niitelaryaaqellikii.",
        "translation": "He probably hears that ancient traditional wisdom."
    },
    "220": {
        "startTime": 2203.621,
        "endTime": 2209.933,
        "transcript": "Tamaa-i qantukurtairucami.",
        "translation": "It's because no one speaks about them anymore."
    },
    "221": {
        "startTime": 2210.071,
        "endTime": 2224.134,
        "transcript": "Atam tamakut tamaa-i angullrenka qalaruyut'seng cimiqetaarpek'naku.",
        "translation": "You see, the people I was born in time to see didn't change the instruction they were given."
    },
    "222": {
        "startTime": 2224.146,
        "endTime": 2229.821,
        "transcript": "Atauciq tua-i atauciuluku qalarutkuratuat.",
        "translation": "They spoek of one thing as one and the same."
    },
    "223": {
        "startTime": 2229.877,
        "endTime": 2240.415,
        "transcript": "Uum qalartaqami qanrutkaqluku. Akaurpailgan allam uum qanraqami qanrutkaqluku.",
        "translation": "When one spoke, he spoke of it. Before long, when another spoke, he spoke of it [in the same way]."
    },
    "224": {
        "startTime": 2240.49,
        "endTime": 2250.778,
        "transcript": "Tamaa-i tamakunek tegganrurtellrianek qalarutkescairucameng",
        "translation": "Because they have no more elders to speak to them"
    },
    "225": {
        "startTime": 2250.866,
        "endTime": 2256.241,
        "transcript": "Qanruyun man'a qanrutkuranriraat",
        "translation": "They don't speak of this traditional wisdom anymore"
    },
    "226": {
        "startTime": 2256.26,
        "endTime": 2262.335,
        "transcript": "Nang'ngameng tamakut qalarutkestek'lallrit.",
        "translation": "Because there's no more of those who used to speak of them."
    },
    "227": {
        "startTime": 2285.435,
        "endTime": 2290.198,
        "transcript": "Tau͡gaam-llu tamaa-i wani qanrucimalallruukuk-llu tua-i.",
        "translation": "But we would also be instructed."
    },
    "228": {
        "startTime": 2290.21,
        "endTime": 2294.51,
        "transcript": "Waten-llu alerqulallruakuk aatamegnuk:",
        "translation": "And our father would instruct us like this:"
    },
    "229": {
        "startTime": 2294.517,
        "endTime": 2304.167,
        "transcript": "Caranglluut-gguq enem iluani carrirturluki. Carrirturluki-gguq cat tamalkuita natret.",
        "translation": "He said to clean the debris in the house. He said to clean everything, the floors."
    },
    "230": {
        "startTime": 2305.486,
        "endTime": 2309.536,
        "transcript": "Cat-llu pellernarqengraata ciqirqelluki.",
        "translation": "And though feel gross, to dump them."
    },
    "231": {
        "startTime": 2309.543,
        "endTime": 2314.868,
        "transcript": "Umyuartequlluki-llu-gguq ciqitaqluki",
        "translation": "He also told us to think as we dumped them"
    },
    "232": {
        "startTime": 2314.887,
        "endTime": 2322.499,
        "transcript": "Picuyuglunuk, wall' unguvamayuglunuk, wall'u assirlinuk yuuyuglunuk naulluuyuunanuk.",
        "translation": "That we want to be good at hunting and gathering, or that we want to live long, or that we want to live well without sickness."
    },
    "233": {
        "startTime": 2322.512,
        "endTime": 2331.037,
        "transcript": "Wall'u kenirmigluki-llu-gguq anutaqluki caarrluut waten piluki.",
        "translation": "Or, he also said to carry the debris in our front hems and take them out, like this."
    },
    "234": {
        "startTime": 2331.306,
        "endTime": 2336.818,
        "transcript": "Wavet kenimun piluki anutaqluki-gguq.",
        "translation": "He said to take them out, putting them in the front hem here."
    },
    "235": {
        "startTime": 2337.081,
        "endTime": 2344.019,
        "transcript": "Atam-gguq tamaani yuut wani tanqingqerrsulriit",
        "translation": "Look, he said, the people back then who wanted light"
    },
    "236": {
        "startTime": 2344.544,
        "endTime": 2353.894,
        "transcript": "Tanqingqerrsulriit clean up-aarturluteng tamakut pitullrulliniut, tuaten essuiculriit-gguq.",
        "translation": "Those people who wanted to have light would always clean up, the ones he said wanted to be pure."
    },
    "237": {
        "startTime": 2354.776,
        "endTime": 2366.426,
        "transcript": "Ilait-gguq tua-i tuaten piuratulit naulluuyuit[aqut]. Naulluuyuunateng-llu-gguq tamakut yuut.",
        "translation": "He same some who always do that would never get sick. He also said those people never got sick."
    },
    "238": {
        "startTime": 2368.195,
        "endTime": 2381.408,
        "transcript": "Akumegteggun-llu angllumanrilnge'rmeng tamakut akumegteggun-gguq tanqigmek anllungaqluteng, alimeng-llu nuugitgun, maaggun-llu pugyaramegteggun.",
        "translation": "And with their hems, he said that though they weren't baptized, they would emit light from their hems, and the tips of their sleeves, and here from their neck openings."
    },
    "239": {
        "startTime": 2381.42,
        "endTime": 2389.708,
        "transcript": "Waten tanqigmek anllungaqluteng. Tarrarteng'e'rmeng-llu ellami tan'gerciyuunateng.",
        "translation": "They emit light like this. And though they walk outside, it's not dark for them."
    },
    "240": {
        "startTime": 2389.721,
        "endTime": 2392.583,
        "transcript": "Tamaa-i tuaten qanrutetullruakuk.",
        "translation": "That's what he used to tell us."
    },
    "241": {
        "startTime": 2392.596,
        "endTime": 2399.821,
        "transcript": "Tamakut-ll' angllumanrilnguuyaaqluteng, nalluvkenateng tamaa-i.",
        "translation": "And though they weren't baptized, they knew that."
    },
    "242": {
        "startTime": 2399.827,
        "endTime": 2408.44,
        "transcript": "Tuamtellu-gguq naulluulriit pelqevkenaki uqlautekengramteki kenugtelarlaput.",
        "translation": "Then he said that we should not be squeamish over those who are sick and clean them up though we get dirty."
    },
    "243": {
        "startTime": 2408.452,
        "endTime": 2418.827,
        "transcript": "Tamaa-i-gguq carrluk-gguq yugnun agtuucuituq. Menuurcuituq-gguq yuk kevgiulria.",
        "translation": "He said that impurities do not affect people. He said that a person who serves others does not become impure."
    },
    "244": {
        "startTime": 2443.408,
        "endTime": 2448.833,
        "transcript": "Mat'um nalliini anagutpiarluteng eneput.",
        "translation": "These days, our houses are excessive."
    },
    "245": {
        "startTime": 2448.839,
        "endTime": 2455.089,
        "transcript": "We're rich right now. We have everything in the house.",
        "translation": "We're rich right now. We have everything in the house."
    },
    "246": {
        "startTime": 2455.246,
        "endTime": 2461.971,
        "transcript": "Ca tamalkuan avaliqluku tuar wangkuta Kass'at, Yuuluta tau͡gken.",
        "translation": "We have everything, like we're Caucasian, yet we're Yup'ik."
    },
    "247": {
        "startTime": 2462.452,
        "endTime": 2478.115,
        "transcript": "Tua-i-llu wiinga taukuni Cakayiinkuni, Johnny Samson-aaq trading post-arluni Nunapicuarmi uitavallutullruunga nasaurluulua.",
        "translation": "Then me, with Johnny Samson having a trading post in Nunapitchuk, I mostly stayed there with Cakayak and family as a girl."
    },
    "248": {
        "startTime": 2478.127,
        "endTime": 2485.652,
        "transcript": "Nulirra tang una cassiyaayuunani. Iciw' tua-i mulngaku'urngataqluni.",
        "translation": "His wife, you see, didn't do much. You know, it seemed like she was being careful."
    },
    "249": {
        "startTime": 2485.671,
        "endTime": 2494.946,
        "transcript": "Wiinga tang eruringuarturnaurtua. Agleqsaunii-llu maybe ten years old, or nine tamaani.",
        "translation": "You see, I would wash dishes. And I didn't menstruate [until] maybe ten years old, or nine back then."
    },
    "250": {
        "startTime": 2496.165,
        "endTime": 2502.14,
        "transcript": "Cat-llu makut perrirturaraqluki pisqellaaki taum nulirran.",
        "translation": "And I would wipe things down since his wife told me to."
    },
    "251": {
        "startTime": 2502.584,
        "endTime": 2505.709,
        "transcript": "Cunaw' tang Kassaungamek.",
        "translation": "Apparently, it's because they were Caucasian."
    },
    "252": {
        "startTime": 2505.715,
        "endTime": 2510.753,
        "transcript": "Tua-i-w' half breed, avguami-w' uinga. Nulirra-w' caullrua?",
        "translation": "Half breed, because her husband was half. I'm not sure what his wife was."
    },
    "253": {
        "startTime": 2510.766,
        "endTime": 2512.778,
        "transcript": "Tuaten wii anglilua.",
        "translation": "That's how I grew up."
    },
    "254": {
        "startTime": 2512.791,
        "endTime": 2520.554,
        "transcript": "Utertaqama-llu, uitarrlainanrilama ilamnun-am, family-mnun utertaqama",
        "translation": "And when I went home, because I didn't stay there all the time, when I went home to my family"
    },
    "255": {
        "startTime": 2520.566,
        "endTime": 2525.466,
        "transcript": "Imkuni Kass'ani pilalqa ayuqeliluku enemteńi.",
        "translation": "I would do at home what I did at the Caucasians'."
    },
    "256": {
        "startTime": 2525.485,
        "endTime": 2531.61,
        "transcript": "Cat makut kitukcaarnaunka, cunaw' tang dust out-alallrullikenka-ll' cat.",
        "translation": "I would work on these things, and I'd apparently dust things out."
    },
    "257": {
        "startTime": 2531.616,
        "endTime": 2535.179,
        "transcript": "Assircaarturluki pinaunka tang.",
        "translation": "You see, I would thoroughly [clean] things."
    },
    "258": {
        "startTime": 2535.191,
        "endTime": 2538.429,
        "transcript": "Tua-i taukugnek elillua.",
        "translation": "I learned from them."
    },
    "259": {
        "startTime": 2538.442,
        "endTime": 2547.329,
        "transcript": "Mat'um nalliini high school, college pitanguq.",
        "translation": "These days, there are high schools, colleges."
    },
    "260": {
        "startTime": 2547.342,
        "endTime": 2558.704,
        "transcript": "Umyuarteq'lartua, \"Makuskiq maa-i nallunritpiarpagtut, qaillun-llu enem iluan clean up-aallerkaanek.\"",
        "translation": "I think, \"These people know so much, including how to clean up the inside of a house.\""
    },
    "261": {
        "startTime": 2559.205,
        "endTime": 2568.392,
        "transcript": "Tuaten umyuarteq'lartua. Tuaten wii ayuqelqa-am Kass'ani uitaqtaqalqa pitekluku elitellruunga tamatumek.",
        "translation": "That's what I think. Because of what I was like when I stayed with Caucasians for a while, I learned that."
    },
    "262": {
        "startTime": 2569.317,
        "endTime": 2581.955,
        "transcript": "Tua-i-llu mat'um nalliini wii, arnat tauni cali Nunapicuarni arnassagaq au͡gna, arnassagaurpallrunritliniuq taum nalliini.",
        "translation": "Then during that time, an old woman there in Nunapitchuk, she hadn't been a very old woman during that time."
    },
    "263": {
        "startTime": 2581.968,
        "endTime": 2583.83,
        "transcript": "Ceńirrviktullruaqa.",
        "translation": "I used to visit her."
    },
    "264": {
        "startTime": 2583.843,
        "endTime": 2588.993,
        "transcript": "Tauna tang iternaurtua arnaq eruriqcaarall' caminek.",
        "translation": "I would go in, and that woman would be washing her things."
    },
    "265": {
        "startTime": 2589.012,
        "endTime": 2594.287,
        "transcript": "Saanini-ll' makut perriqcaarturnaurai waten kaminiami qaingani.",
        "translation": "And she would wipe her kettles like this on top of her stove."
    },
    "266": {
        "startTime": 2594.693,
        "endTime": 2602.968,
        "transcript": "Tua-i-ll' itraqama taum arnam uutautengqellaan saarralanek, iciw' saarralanek uucitulriit yuut?",
        "translation": "Then when I went in, since that woman had burnt sugar candy, you know how people make burnt sugar candy?"
    },
    "267": {
        "startTime": 2602.987,
        "endTime": 2606.724,
        "transcript": "Wii tuar candy-rtaitellrull' tamaani.",
        "translation": "It seemed there was no candy back then to me."
    },
    "268": {
        "startTime": 2606.737,
        "endTime": 2612.249,
        "transcript": "Taum arnam uutamek cikiqernauraanga, wiinga-ll' iqemkarluku.",
        "translation": "That woman would give me burnt sugar candy, and I'd put it in my mouth."
    },
    "269": {
        "startTime": 2612.262,
        "endTime": 2616.175,
        "transcript": "Saarralarninaq neqniqluni.",
        "translation": "It tasted good like sugar."
    },
    "270": {
        "startTime": 2616.187,
        "endTime": 2619.725,
        "transcript": "Tamana pitekluku tauna arnaq ullagyutullruaqa.",
        "translation": "I liked to go see that woman for that reason."
    },
    "271": {
        "startTime": 2620.0,
        "endTime": 2625.625,
        "transcript": "Taum caaqami pilaraanga arnam, \"Ilung,\" ilungaqliniamia",
        "translation": "Sometimes, that woman would say to me, \"Cousin,\" because I was her cousin"
    },
    "272": {
        "startTime": 2625.631,
        "endTime": 2636.931,
        "transcript": "\"Ilung, wangtun piyaureskuvet, aipangkuvet, wangtun pilaqina. Cangqelarniartuten atam.",
        "translation": "Cousin, when you're on your own like me, when you get married, do what I do. Watch, you'll have things [to use and eat]."
    },
    "273": {
        "startTime": 2637.588,
        "endTime": 2646.063,
        "transcript": "\"Caten eruyuunaki enevet ilauni,' tua-i nasaurlullraulua, \"uitaskuvki",
        "translation": "\"If you don't wash things in your home,\" I was a little girl, \"if you leave them alone"
    },
    "274": {
        "startTime": 2646.082,
        "endTime": 2655.069,
        "transcript": "\"Dust-am atam patularniarai, kiituani assiirucan qel'kenriran eggluku-llu.\"",
        "translation": "\"Watch, dust will cover them until eventually you don't keep it since it got bad, and you throw it away.\""
    },
    "275": {
        "startTime": 2655.082,
        "endTime": 2660.894,
        "transcript": "Tauna-llu nutarauyaaqluni, tau͡gaam dust-am iqampatuluku.",
        "translation": "And it may be new, but dust makes it very dirty."
    },
    "276": {
        "startTime": 2660.907,
        "endTime": 2667.432,
        "transcript": "Tua-i-ll' aglumanairulluni piksuumiirutnariluni. Taum tang pitullrukiinga tuaten.",
        "translation": "Then it becomes undesirable and not good to keep. That's what she used to tell me."
    },
    "277": {
        "startTime": 2685.213,
        "endTime": 2690.363,
        "transcript": "Tua-i-ll' mat'um nalliini waten cali qanlartut:",
        "translation": "Then these days, they also say this:"
    },
    "278": {
        "startTime": 2690.495,
        "endTime": 2699.232,
        "transcript": "\"Arnanek-gguq irnialek arnaq, atam-gguq taum arnam aanani tangvagniaraa enem iluani.",
        "translation": "\"A woman with female children, watch, that woman will watch her mother in the house."
    },
    "279": {
        "startTime": 2699.245,
        "endTime": 2707.345,
        "transcript": "\"Tua-i-llu-gguq calillra, callra arnam cali taum irniaran ayuqeliyugngaluku.\"",
        "translation": "\"Then what she does, that woman's child can copy what she does.\""
    },
    "280": {
        "startTime": 2708.539,
        "endTime": 2711.202,
        "transcript": "Piciugut makut.",
        "translation": "These are true."
    },
    "281": {
        "startTime": 2711.302,
        "endTime": 2717.202,
        "transcript": "Wiinga-ll' waniw' nine-aanek irniangqertua, five girls, four boys.",
        "translation": "And now, I have nine children, five girls, four boys."
    },
    "282": {
        "startTime": 2717.446,
        "endTime": 2726.221,
        "transcript": "Ukut-llu five girls ayuqenritut tamarmeng. Iciw' ayuqenritut.",
        "translation": "And these five girls are all different. You know, they're different."
    },
    "283": {
        "startTime": 2729.39,
        "endTime": 2733.352,
        "transcript": "Tamalkuita-ll' taukut wii kenkepiarluki.",
        "translation": "And I love all of them."
    },
    "284": {
        "startTime": 2733.578,
        "endTime": 2744.753,
        "transcript": "Tua-i-ll' caliyaurcama, cali mingeqsaurcama tua-i, ukut-ll' angliriluteng ukut yuungnaqengluteng paniinka",
        "translation": "Then when I started working, and I started sewing, and my daughters here grew up and started living on their own"
    },
    "285": {
        "startTime": 2745.484,
        "endTime": 2749.334,
        "transcript": "Caliurnaunka, mingqurluki-ll'.",
        "translation": "I would always make them things, and sew for them."
    },
    "286": {
        "startTime": 2749.728,
        "endTime": 2758.353,
        "transcript": "Iliini enaitnun it'lartua cailkami taun' im' mingqelqa. Umyuaqa tang pinaurtuq.",
        "translation": "I sometimes go in their houses and see what I sewed on the floor. My mind would be hurt."
    },
    "287": {
        "startTime": 2758.959,
        "endTime": 2764.634,
        "transcript": "Cunawa-m' tua-i assircaarluku call' tauna uitaarkaq cailkamtelluku.",
        "translation": "It turned out that what they were supposed to keep well was on the floor."
    },
    "288": {
        "startTime": 2764.64,
        "endTime": 2768.915,
        "transcript": "Iliinun panima iternaurtua, neat.",
        "translation": "I would go into one of my daughter's [houses], [and it's] neat."
    },
    "289": {
        "startTime": 2769.559,
        "endTime": 2774.359,
        "transcript": "Aren, caliallrenka-ll' makut kenkumaluteng.",
        "translation": "Oh my, and the ones I made would be treated with love."
    },
    "290": {
        "startTime": 2774.616,
        "endTime": 2784.966,
        "transcript": "Tua-i-ll' tuaten piama, waniwa irniamni five girls, malruk, atrit aperngaitanka",
        "translation": "Then when I did that, among my children, five girls, two of them, I won't mention their names"
    },
    "291": {
        "startTime": 2785.385,
        "endTime": 2788.885,
        "transcript": "Wii tangerturallemni neat.",
        "translation": "From what I've seen, [they're] neat."
    },
    "292": {
        "startTime": 2789.229,
        "endTime": 2792.529,
        "transcript": "Kass'at apqiitnek neat.",
        "translation": "As they say in English, neat."
    },
    "293": {
        "startTime": 2792.873,
        "endTime": 2797.986,
        "transcript": "Assirtuk. Tamarmeng assiryaaqut.",
        "translation": "They're good. Actually, all of them are good."
    },
    "294": {
        "startTime": 2798.098,
        "endTime": 2807.373,
        "transcript": "Tua-i-ll' waten piunga: mingqaallrenka aturiallrenka taukuk care-aqapiarlukek.",
        "translation": "Then I realized this: those two would take good care of what I sewed, the clothes I made."
    },
    "295": {
        "startTime": 2807.379,
        "endTime": 2816.317,
        "transcript": "Arcaqerluni-am aipaan care-aamiki eniinun itraqama tua-i tanglaamteki.",
        "translation": "The other one especially takes good care of them, since we see them when I go in her house."
    },
    "296": {
        "startTime": 2817.03,
        "endTime": 2825.342,
        "transcript": "Kiagmi caliallrenka mingqaat atkuut, piluguut furs, fur clothes",
        "translation": "In the summer, what I made by sewing, parkas, skin boots, furs, fur clothes"
    },
    "297": {
        "startTime": 2825.355,
        "endTime": 2833.343,
        "transcript": "Kiagmi tangerqayuitanka eniinun iluani, nothing. She put them away.",
        "translation": "I never see them in her house in the summer, nothing. She put[s] them away."
    },
    "298": {
        "startTime": 2834.081,
        "endTime": 2836.768,
        "transcript": "Iciw' put away-larai.",
        "translation": "You know, she puts them away."
    },
    "299": {
        "startTime": 2836.781,
        "endTime": 2845.968,
        "transcript": "Kass'ani nallunritua fur-at uitavingqertut pitalqellriamek enemek.",
        "translation": "In Caucaisian homes, I know that fur [clothes] have places, appropriate [storing] spaces."
    },
    "300": {
        "startTime": 2845.981,
        "endTime": 2850.931,
        "transcript": "Kiircetevkenaki, nengllirpek'nani, maybe medium.",
        "translation": "It's not hot, not cold, maybe medium."
    },
    "301": {
        "startTime": 2850.938,
        "endTime": 2853.55,
        "transcript": "Tua-i-ll' fur-ani assirluni.",
        "translation": "Then their fur is good."
    },
    "302": {
        "startTime": 2853.551,
        "endTime": 2864.401,
        "transcript": "Atam cat wani makut skin-at agaurarqameng years and years aturviirutetuut uuluteng.",
        "translation": "You see, when things made of skin hang for years and years, they [?come apart] and can't be worn anymore."
    },
    "303": {
        "startTime": 2865.158,
        "endTime": 2869.495,
        "transcript": "Tegukumni-ll' una atkuk allegluni. Uuluni.",
        "translation": "Then when I take this parka, it rips. It [?comes apart]."
    },
    "304": {
        "startTime": 2896.845,
        "endTime": 2907.795,
        "transcript": "Mat'um nalliini arcaqalriaruuq tukuussiyaagata yuut, Agayutem cikiutekngateng cat.",
        "translation": "These days, it's worse because people are too rich, since things are God's gifts."
    },
    "305": {
        "startTime": 2907.802,
        "endTime": 2911.689,
        "transcript": "Enem iluani cat Agayutem cikiutekai.",
        "translation": "THings in the home are God's gifts."
    },
    "306": {
        "startTime": 2911.702,
        "endTime": 2917.827,
        "transcript": "Arnam take care-ararkaugai assirluki.",
        "translation": "A woman must take good care of them."
    },
    "307": {
        "startTime": 2917.846,
        "endTime": 2922.833,
        "transcript": "Ilii angutem pituuq atam.",
        "translation": "Some men do that, you see."
    },
    "308": {
        "startTime": 2922.846,
        "endTime": 2925.996,
        "transcript": "Wii waniw' nengaungqertua ayuqenrilngurnek.",
        "translation": "Now, I have different sons-in-law."
    },
    "309": {
        "startTime": 2926.09,
        "endTime": 2930.84,
        "transcript": "Iliin uinga nuliani ikayuayunqeggluku.",
        "translation": "Some of their husbands like to help his wife."
    },
    "310": {
        "startTime": 2931.047,
        "endTime": 2935.209,
        "transcript": "Irnianka-w' tua-i tuaten ayuqut ilait.",
        "translation": "Some of my children are like that."
    },
    "311": {
        "startTime": 2935.222,
        "endTime": 2939.71,
        "transcript": "Iliin-llu uinga uitauratuluni.",
        "translation": "And some of their husbands is sedentary."
    },
    "312": {
        "startTime": 2939.723,
        "endTime": 2948.235,
        "transcript": "Arniin ellmikun kiiryugluni caliluni, angutiin-ll' im' ikayuyuunaku angutnguami-wa.",
        "translation": "The woman is hot as she works alone, and the man doesn't help because he's a man."
    },
    "313": {
        "startTime": 2948.248,
        "endTime": 2956.986,
        "transcript": "Angutet qagaani caliarkaungameng outside work, arnaq-llu enem iluani inside work.",
        "translation": "Because men are supposed to work out there, outside work, and women in the house, inside work."
    },
    "314": {
        "startTime": 2956.999,
        "endTime": 2963.586,
        "transcript": "Tau͡gaam ayuqenrilata yuut ayuqenrilngurnek-am ukut paniinka aipangqelartut.",
        "translation": "But because people are different, my daughters have different spouses."
    },
    "315": {
        "startTime": 2963.786,
        "endTime": 2971.986,
        "transcript": "Ilaita nuliat tamakut-am wii assikpiaranka. Aipait makut aipateng care-aqait.",
        "translation": "I really like some of their wives. Their spouses take care of their spouses."
    },
    "316": {
        "startTime": 2971.993,
        "endTime": 2974.63,
        "transcript": "Anglill' taumi assirpaa.",
        "translation": "Oh my, that's really good."
    },
    "317": {
        "startTime": 2974.643,
        "endTime": 2976.73,
        "transcript": "Pituaput.",
        "translation": "We tell them."
    },
    "318": {
        "startTime": 2977.03,
        "endTime": 2979.318,
        "transcript": "Keneknaqluteng.",
        "translation": "They are dear."
    },
    "319": {
        "startTime": 2979.606,
        "endTime": 2985.506,
        "transcript": "Uitauryulriit waten, qaill' atak' apqerlaku?",
        "translation": "Those who are sedentary like this, how should I say it?"
    },
    "320": {
        "startTime": 2985.7,
        "endTime": 2989.513,
        "transcript": "Mat'um nalliini-llam qanlartut, \"weird.\"",
        "translation": "These days, they say, \"weird.\""
    },
    "321": {
        "startTime": 2989.525,
        "endTime": 2992.875,
        "transcript": "Weird-aq una wii taringyuitaqa.",
        "translation": "I don't understand this word, \"weird.\""
    },
    "322": {
        "startTime": 2992.882,
        "endTime": 2996.594,
        "transcript": "Tuar-llu tang tauna tuaten uitauralria weird-alria.",
        "translation": "And it seems one who's sedintary like that is weird."
    },
    "323": {
        "startTime": 2998.757,
        "endTime": 3006.907,
        "transcript": "Wiinga atam qalartaqama temcinarqellrianek avuaqluku pituunga.",
        "translation": "You see, when I speak, I add in some funny things."
    },
    "324": {
        "startTime": 3006.914,
        "endTime": 3012.489,
        "transcript": "Tua-i man'a maa-i arcaqerluku qanruteksullruaqa.",
        "translation": "This is especially what I want to talk about."
    },
    "325": {
        "startTime": 3012.508,
        "endTime": 3017.683,
        "transcript": "Makut teenager-aat mat'um nalliini",
        "translation": "These teenagers these days"
    },
    "326": {
        "startTime": 3021.064,
        "endTime": 3027.927,
        "transcript": "Catussiyaanritellrat I sorry for them.",
        "translation": "I [am] sorry for them because they don't do much."
    },
    "327": {
        "startTime": 3028.464,
        "endTime": 3036.989,
        "transcript": "Aanait-llu caqtartu'rnaurtut, pania-w' un' inarrluni naaqill'.",
        "translation": "And their mother would do chores, while the daughter here lays down and reads."
    },
    "328": {
        "startTime": 3037.008,
        "endTime": 3042.02,
        "transcript": "Tua-i-w' puqiameng-llu pillilriit kalikanek.",
        "translation": "It's probably because they're skilled with books."
    },
    "329": {
        "startTime": 3042.033,
        "endTime": 3048.383,
        "transcript": "Ilii-ll' apqiitnek video, teng teng teng teng teng teng.",
        "translation": "And some [do] what they call video [games], ding ding ding ding ding ding."
    },
    "330": {
        "startTime": 3049.527,
        "endTime": 3055.202,
        "transcript": "Aqumluni how many, couple hours",
        "translation": "He sits for how many, couple hours"
    },
    "331": {
        "startTime": 3055.871,
        "endTime": 3061.608,
        "transcript": "Calinami nangerrluni aanani ikayurluku wall'u atani.",
        "translation": "During the time to work, standing up and helping their mother or father."
    },
    "332": {
        "startTime": 3063.408,
        "endTime": 3072.408,
        "transcript": "Tua-i makunek qalartua, ilakelaatgu-llu Agayun.",
        "translation": "I am speaking of these, also because they are acquainted with God."
    },
    "333": {
        "startTime": 3072.415,
        "endTime": 3081.702,
        "transcript": "Agayutem cikiutai enem iluani take care-arnarqelliniut assircaarluki.",
        "translation": "It turns out, we must take good care of God's gifts in the house."
    },
    "334": {
        "startTime": 3110.39,
        "endTime": 3115.152,
        "transcript": "Waten-am qantullruata au͡gkut wani eneqeraqluki piunga:",
        "translation": "Since people back then used to say this, I remember them:"
    },
    "335": {
        "startTime": 3115.165,
        "endTime": 3123.015,
        "transcript": "Arnat-gguq, irniamta wangkuta aanaulriani cauralput ayuqeliyugngaa.",
        "translation": "They said that for women, our children, for those of us who are mothers, can copy what we do."
    },
    "336": {
        "startTime": 3123.134,
        "endTime": 3125.009,
        "transcript": "Piciuguq.",
        "translation": "It's true."
    },
    "337": {
        "startTime": 3125.065,
        "endTime": 3134.878,
        "transcript": "Mingquratukuma panima ayuqeliyugngaatnga, mingqaqluteng-llu.",
        "translation": "If I always sew, my daughters can copy me, and start sewing."
    },
    "338": {
        "startTime": 3134.903,
        "endTime": 3139.753,
        "transcript": "Tau͡gaam-wa mat'um nalliini elitnauq man'a cavagta.",
        "translation": "But these days, this school is too much [of an obstacle]."
    },
    "339": {
        "startTime": 3141.197,
        "endTime": 3148.685,
        "transcript": "Tua-i nanrarngaitanka irnianka. Cuqkuuryugngaanka cuqyutekluki.",
        "translation": "I will not praise my children. I can use them as examples."
    },
    "340": {
        "startTime": 3148.76,
        "endTime": 3157.623,
        "transcript": "Ataucimek-llu maa-i irniangqertua college-aalalriamek. Allrakut tang tua-i maa-i amllerilriit.",
        "translation": "Now, I have one child who goes to college. It's been many years now."
    },
    "341": {
        "startTime": 3157.635,
        "endTime": 3161.01,
        "transcript": "Apqiitnek drop out-araqluni.",
        "translation": "[S]he drops out, as they call it."
    },
    "342": {
        "startTime": 3161.754,
        "endTime": 3166.304,
        "transcript": "Tang makut-wa qaill' piat?",
        "translation": "What's going on with these people?"
    },
    "343": {
        "startTime": 3166.861,
        "endTime": 3177.998,
        "transcript": "Makumek-llu tang caliyaramek maani yuuluni nalluluni.",
        "translation": "And, you see, [s]he doesn't know how to live here and work."
    },
    "344": {
        "startTime": 3178.561,
        "endTime": 3183.748,
        "transcript": "Caliyuyuunani-ll', naaqiq tau͡gaam.",
        "translation": "And [s]he doesn't want to work, only read."
    },
    "345": {
        "startTime": 3185.023,
        "endTime": 3190.098,
        "transcript": "Tua-llu cali cuqkuurluku, cuqyutkaqluki-w' canrilnguq.",
        "translation": "And using another as an example, it's okay to use them as examples."
    },
    "346": {
        "startTime": 3190.242,
        "endTime": 3196.054,
        "transcript": "Atauciq irniaqa elitnaunermek qessayulallruuq.",
        "translation": "One of my children would be disinclined to go to school."
    },
    "347": {
        "startTime": 3196.067,
        "endTime": 3204.342,
        "transcript": "Cayunqepiaq. Caliyunqeggluni boy-aq, outside work.",
        "translation": "He loves to work. The boy loves to work, outside work."
    },
    "348": {
        "startTime": 3205.448,
        "endTime": 3213.573,
        "transcript": "Nallunritaqa cikuciyunqektallrulria mikluni, mer'icecuunii.",
        "translation": "I know he liked to pack ice when he was small, never letting me be without water."
    },
    "349": {
        "startTime": 3213.579,
        "endTime": 3215.617,
        "transcript": "Qessaitpiaq.",
        "translation": "He was very hard-working."
    },
    "350": {
        "startTime": 3215.63,
        "endTime": 3222.717,
        "transcript": "Wiinga-w' pisqurqeka, iciw' kiingan pistek'lallruamku.",
        "translation": "I would have him do this, you know, because he was my only provider."
    },
    "351": {
        "startTime": 3222.892,
        "endTime": 3233.767,
        "transcript": "Mat'um nalliini tangrraqa caliyaramek qagaani-llu nallunritqapiarluni tauna.",
        "translation": "I see him these days, being very knowledgeable about how to work outside."
    },
    "352": {
        "startTime": 3234.011,
        "endTime": 3243.273,
        "transcript": "Ayagmek, angutngurrluni utaqaurpek'nani, ayagmek tau͡gaam piuralria",
        "translation": "From the beginning, not waiting until he becomes an old man, but one who is active from the beginning"
    },
    "353": {
        "startTime": 3243.899,
        "endTime": 3247.986,
        "transcript": "Apqiitnek Kass'at train-arciqliniuq ellminek.",
        "translation": "As they say in English, he will train himself."
    },
    "354": {
        "startTime": 3247.999,
        "endTime": 3253.149,
        "transcript": "Taukun cali tua-i cuqyuteksugngaaqa yumkun ataucikun.",
        "translation": "I can also provide an example of that through one of my children."
    },
    "355": {
        "startTime": 3253.156,
        "endTime": 3260.518,
        "transcript": "Mat'um nalliini youngest, irniarugama youngest",
        "translation": "These days, the youngest, the youngest of my many children"
    },
    "356": {
        "startTime": 3262.381,
        "endTime": 3266.719,
        "transcript": "Cacetuqutek'la'rqa ellami caarkanun.",
        "translation": "I depend on them for outside chores."
    },
    "357": {
        "startTime": 3266.857,
        "endTime": 3272.632,
        "transcript": "Calinaurtuq tuar taqneq, nallunritqapiarluni.",
        "translation": "They work like an adult, very knowledgeable."
    },
    "358": {
        "startTime": 3274.813,
        "endTime": 3280.463,
        "transcript": "Tua-i tua-i qanengssakanka makut cuqyutekluki.",
        "translation": "I am speaking about these, using them as examples."
    },
    "359": {
        "startTime": 3281.107,
        "endTime": 3286.932,
        "transcript": "Iimteggun tangllemteggun canek elicugngaukut.",
        "translation": "We can learn things by what we see with our eyes."
    },
    "360": {
        "startTime": 3287.313,
        "endTime": 3298.263,
        "transcript": "Iciw' tua-i wiinga aanaka clean up-aatullrunrituq, mingqurluni tau͡gaam",
        "translation": "You know, my mother wouldn't clean up, but she was always sewing"
    },
    "361": {
        "startTime": 3298.282,
        "endTime": 3301.42,
        "transcript": "Clean up-aararkartailan-wa enemta ilua.",
        "translation": "Because there was nothing to clean up in our house."
    },
    "362": {
        "startTime": 3301.433,
        "endTime": 3307.633,
        "transcript": "Tau͡gaam tua-i-w' ava-i qanertua Cakayiinkugni Kassaungamek-wa tua-i [?]",
        "translation": "But I just said that with Cakayak and his spouse, they'd [?] since they were Caucasian."
    },
    "363": {
        "startTime": 3307.64,
        "endTime": 3311.69,
        "transcript": "Maanicetun tau͡gaam ayuqevkenateng; phone-artaunani.",
        "translation": "But it wasn't like here; there were no phones."
    },
    "364": {
        "startTime": 3311.709,
        "endTime": 3314.309,
        "transcript": "Tiiviingqellruut-qaa?",
        "translation": "Did they have TV's?"
    },
    "365": {
        "startTime": 3315.753,
        "endTime": 3321.078,
        "transcript": "Taukugnek qaneryugngaunga taukugnek tamakunek elitellemnek.",
        "translation": "I can speak of them, what I learned from them."
    },
    "366": {
        "startTime": 3347.347,
        "endTime": 3355.284,
        "transcript": "Elitnaullemni tuar tang camek elitellrunrilngua, igketellruami-w' elitnaulqa, carraussiyaallruami.",
        "translation": "It seemed that I didn't learn anything when I went to school because I had so little school, because it was too short."
    },
    "367": {
        "startTime": 3355.484,
        "endTime": 3363.459,
        "transcript": "Egmian wani elitnauryuglua nangteq'nge'rma, allrakunka ikgelengraata-ll' uingetullruameng imkut.",
        "translation": "Though I ached to go to school right away, they took husbands at young ages back then."
    },
    "368": {
        "startTime": 3363.465,
        "endTime": 3367.74,
        "transcript": "Wiinga-am uingevkaqiitnga, igkenateng-ll' allrakunka.",
        "translation": "They had me take a husband, and I was at a young age."
    },
    "369": {
        "startTime": 3367.759,
        "endTime": 3371.596,
        "transcript": "Maani-llu marriage license-aamek piqatallmegni",
        "translation": "And when we were going to get a marriage license here"
    },
    "370": {
        "startTime": 3371.609,
        "endTime": 3379.071,
        "transcript": "Tauna-am commissioner-aamek aterluni marriage license-aanek cikiqengtuli.",
        "translation": "That one who gave out marriage licenses was called a commissioner."
    },
    "371": {
        "startTime": 3379.084,
        "endTime": 3385.034,
        "transcript": "Maa-i-am iliini pilartua, \"Tauna-llam carpakayak iqlullinill'.\"",
        "translation": "Somtimes now, I say, \"That person who thought himself important lied.\""
    },
    "372": {
        "startTime": 3385.041,
        "endTime": 3389.616,
        "transcript": "Sixteen-aallruunga. Sixteen-aallruyugnarqua.",
        "translation": "I was 16. I think I was 16."
    },
    "373": {
        "startTime": 3389.635,
        "endTime": 3395.51,
        "transcript": "Marriage license-aaq-am taitesciigatnirraarluku igarraarluku taitaa.",
        "translation": "After he said he couldn't give a marriage license, he wrote on it and gave it."
    },
    "374": {
        "startTime": 3395.516,
        "endTime": 3404.116,
        "transcript": "Wiinga 18-aaruartellua marriage license-aaq wangkugnun tunlliniluku, allrakunka ilaluki.",
        "translation": "He falsly wrote that I was 18 and gave us the marriage license, raising my age."
    },
    "375": {
        "startTime": 3404.873,
        "endTime": 3409.935,
        "transcript": "Maa-i tuaggun ayagtua allrakunka, allrakuma ilamallrakun.",
        "translation": "Now, I go by that, how my age was raised."
    },
    "376": {
        "startTime": 3409.948,
        "endTime": 3413.223,
        "transcript": "Taumi younger-aanruyaaqua nallunailngurmek.",
        "translation": "I'm certainly younger than that."
    },
    "377": {
        "startTime": 3413.228,
        "endTime": 3423.153,
        "transcript": "Tau͡gaam marriage license, iciw' prove-aqsugngalliniamegteggu tamakutgun kalikanka kitugtellruit aipaqa yuunrillrani.",
        "translation": "But since they could, you know, prove it with that marriage license, they fixed my documents when my spouse passed away."
    },
    "378": {
        "startTime": 3423.384,
        "endTime": 3426.797,
        "transcript": "Tua-i tauna qanrutkela'arqa.",
        "translation": "I speak of that."
    },
    "379": {
        "startTime": 3427.234,
        "endTime": 3433.259,
        "transcript": "Ilailallrulliniut-am allrakunek au͡gkut ciuqvani.",
        "translation": "Those people raised ages back then."
    },
    "380": {
        "startTime": 3433.265,
        "endTime": 3439.515,
        "transcript": "Mat'um nalliini-wa arnassagaurrlni-ll' wall' angukara'urluurrluni nulirtulalria angun.",
        "translation": "These days, they become old women, or a man takes a wife as an old man."
    },
    "381": {
        "startTime": 3439.534,
        "endTime": 3444.309,
        "transcript": "Wall' arnassagaurrluni arnaq uingaqluni mat'um nalliini.",
        "translation": "Or a woman takes a husband as an old woman these days."
    },
    "382": {
        "startTime": 3444.978,
        "endTime": 3451.428,
        "transcript": "Pirpakellruat-qaa tamaani ciuliamta uum irniam wani aipangllerkaa?",
        "translation": "Did our ancestors back then consider it important for a child to get married?"
    },
    "383": {
        "startTime": 3451.447,
        "endTime": 3459.622,
        "transcript": "Aipaagni-w' pirpakliamegteggu imkuk angayuqaagma tua-i allanun-llu qarucetaqlua.",
        "translation": "Probably because my parents thought it was important, they would also have others encourage me."
    },
    "384": {
        "startTime": 3459.628,
        "endTime": 3472.266,
        "transcript": "Atam tamaani aiparkiutulliniiit aiparkaat una yuvriraqluku ayuqucia, qaillun-llu calitacia.",
        "translation": "You see, back then they would choose their [children's] spouses by examines their potential spouses characters, and how much they work."
    },
    "385": {
        "startTime": 3472.279,
        "endTime": 3477.104,
        "transcript": "Iciw' dumb man-amek pivkenateng.",
        "translation": "You know, they wouldn't choose a dumb man."
    },
    "386": {
        "startTime": 3479.098,
        "endTime": 3482.81,
        "transcript": "Mat'um-wa nalliini acirlaku tamian.",
        "translation": "These days, I should call it, tamian [dumb man]."
    },
    "387": {
        "startTime": 3482.823,
        "endTime": 3488.998,
        "transcript": "Ilii uingelartuq, uinga-ll' taun canermek nalluluni.",
        "translation": "Some take a husband, and their husband doesn't know how to do anything."
    },
    "388": {
        "startTime": 3489.004,
        "endTime": 3492.467,
        "transcript": "Iqlunritua. Iqluunga-qaa?",
        "translation": "I'm not lying. Am I lying?"
    },
    "389": {
        "startTime": 3492.604,
        "endTime": 3495.417,
        "transcript": "Wall' angun nulirturaqluni...",
        "translation": "Or a man takes a wife..."
    },
    "390": {
        "startTime": 3496.229,
        "endTime": 3498.004,
        "transcript": "Tua-i tua-i.",
        "translation": "There you have it."
    },
    "391": {
        "startTime": 3498.023,
        "endTime": 3504.448,
        "transcript": "Wiinga wani qanrutkenrilnguaranka makut piciulriit.",
        "translation": "I will not keep myself from speaking about these truths."
    },
    "392": {
        "startTime": 3505.042,
        "endTime": 3515.767,
        "transcript": "Wiinga uikarcullrulliniagnga angayuqaagma, au͡gna-am uikaqa cunaw' ayagyuaqtarluni caneq elisngaq'apiarluku.",
        "translation": "My parents chose a husband for me, and it turned out that my groom to be was a young man who was extremely knowledgeable about how to do things."
    },
    "393": {
        "startTime": 3515.786,
        "endTime": 3518.398,
        "transcript": "Nick, Nick O'Nick.",
        "translation": "Nick, Nick O'Nick."
    },
    "394": {
        "startTime": 3518.774,
        "endTime": 3522.536,
        "transcript": "Aipaqsagutaqa-llu young-apiallrulliniuq.",
        "translation": "And the one I married was apparently very young."
    },
    "395": {
        "startTime": 3522.549,
        "endTime": 3530.699,
        "transcript": "Marriage license-aami allarakurlunuk, Nick-aq 22, wiinga-llu 18 married-aallemegni.",
        "translation": "Our ages were on the marriage licesnse, Nick was 22, and I was 18 when we married."
    },
    "396": {
        "startTime": 3531.268,
        "endTime": 3541.193,
        "transcript": "Waten pilallruanga aanama: qessavkenii-gguq tauna pikilaku. Castekaqerput.",
        "translation": "My mother used to tell me this: I should not be lazy as I work with him. He is our provider."
    },
    "397": {
        "startTime": 3541.399,
        "endTime": 3544.774,
        "transcript": "Taum-gguq uima cascirciqaakut.",
        "translation": "She said my husband will provide for us."
    },
    "398": {
        "startTime": 3544.78,
        "endTime": 3550.318,
        "transcript": "Una-wa anngaqa TB-rluni tua-i assiirulluni cayuunani.",
        "translation": "My older brother was incapacitated by TB and couldn't do anything."
    },
    "399": {
        "startTime": 3550.331,
        "endTime": 3555.706,
        "transcript": "Tua-i taumek-ll' anngamenk umyuarniulallruama",
        "translation": "Because I would also worry about my older brother"
    },
    "400": {
        "startTime": 3555.725,
        "endTime": 3561.037,
        "transcript": "Tua-i tuqukan-llu, tang umyuarteqtullrullinilriakut wangkuta.",
        "translation": "And if he dies, you see, we used to think of the future."
    },
    "401": {
        "startTime": 3561.038,
        "endTime": 3565.588,
        "transcript": "Allrakunka-am ikgelengraata umyuarteq'lallrullinilrianga.",
        "translation": "Though I was young in age, I used to think of the future."
    },
    "402": {
        "startTime": 3565.607,
        "endTime": 3574.395,
        "transcript": "Umyuarteqaqlua-ll' waten: \"Taum-am anngarma nulirran, 'Pikina,'\" qarutelaanga.",
        "translation": "Then I would think this: \"My husband's wife, 'Step up,'\" because she encouraged me."
    },
    "403": {
        "startTime": 3575.12,
        "endTime": 3584.283,
        "transcript": "Tua-i-ll' umyuarteq'langua waten: pingaitniaqlua kenkiama allamek, love-arlua.",
        "translation": "Then I started thinking like this: I will not, because I loved another."
    },
    "404": {
        "startTime": 3584.42,
        "endTime": 3593.583,
        "transcript": "Tua-i-w' mat'um nalliini qanrutekciqlikeka allamek loving-aarlua.",
        "translation": "These days, I will say that I loved another."
    },
    "405": {
        "startTime": 3593.67,
        "endTime": 3598.82,
        "transcript": "Assiqtarluni tauna alla, wii tang tua-i kenkaqluku",
        "translation": "That other one was charming, and I loved him, you see"
    },
    "406": {
        "startTime": 3598.827,
        "endTime": 3604.377,
        "transcript": "Una tua͡g uikaqa date-aqallruvkenaku takaqluku.",
        "translation": "But without having dated my groom to be, I was withdrawn around him."
    },
    "407": {
        "startTime": 3604.784,
        "endTime": 3613.709,
        "transcript": "Tua-i-ll' tuani aanama tang tua-i pilaanga-ll' uum, \"Castekaqerput. Tang castekarput tauna casciigalnguq.\"",
        "translation": "Then at that time, my mother also used to tell me, \"He'll be our provider. Look, our provider can't do anything.\""
    },
    "408": {
        "startTime": 3613.74,
        "endTime": 3621.79,
        "transcript": "Iliini tang... waten-llam pilallrukaitkut: aqumluta-gguq atam umyuartequraqa'aqluta.",
        "translation": "Sometimes, you see... they also used to tell us this: we should sit and ponder for a while."
    },
    "409": {
        "startTime": 3621.809,
        "endTime": 3623.897,
        "transcript": "Wiinga allutalallrulliniaqa.",
        "translation": "I used to do that."
    },
    "410": {
        "startTime": 3623.91,
        "endTime": 3627.485,
        "transcript": "Iliini tang umyuarteqeqcaarnaurtua waten:",
        "translation": "Sometimes, you see, I would think like this:"
    },
    "411": {
        "startTime": 3627.491,
        "endTime": 3635.841,
        "transcript": "\"Ingna-llam anngaqa tuqukan pisqestek'lalqa umyuarniurciqua.\"",
        "translation": "\"If my brother over there dies who used to provide for me, I will regret it.\""
    },
    "412": {
        "startTime": 3658.598,
        "endTime": 3664.085,
        "transcript": "Umyuarniuryaraq-llu nalluveknaki 16, nasaurlullraulua.",
        "translation": "I knew about being worried at 16, as a little girl."
    },
    "413": {
        "startTime": 3664.098,
        "endTime": 3666.498,
        "transcript": "Ceńirtaarteńgulua.",
        "translation": "I would visit others."
    },
    "414": {
        "startTime": 3666.505,
        "endTime": 3668.83,
        "transcript": "Tuaten tang umyuarteqnaurtua.",
        "translation": "You see, I would think like that."
    },
    "415": {
        "startTime": 3668.849,
        "endTime": 3671.911,
        "transcript": "Tua-i-ll' caqerlua angerlua.",
        "translation": "Then one day, I agreed."
    },
    "416": {
        "startTime": 3673.099,
        "endTime": 3678.824,
        "transcript": "Aren maaten tua-i aipaqsagutaqa tauna aipaqa takaqluku.",
        "translation": "Oh my, it turned out that when married him, I was withdrawn around my spouse."
    },
    "417": {
        "startTime": 3679.593,
        "endTime": 3684.168,
        "transcript": "Inartaqlua waten aklutuumarma canianun.",
        "translation": "I would go to bed by him fully clothed like this."
    },
    "418": {
        "startTime": 3684.499,
        "endTime": 3690.312,
        "transcript": "Iciw' u͡gayarluteng maa-i gown-arluteng caluteng inartelallinilriit.",
        "translation": "You know, they undress, put on gowns or something, and go to bed now."
    },
    "419": {
        "startTime": 3690.324,
        "endTime": 3695.737,
        "transcript": "Aklutuumarma wii inarrnaurtua caniani taum aiparma.",
        "translation": "I would go to bed fully clothed by my spouse."
    },
    "420": {
        "startTime": 3695.749,
        "endTime": 3703.687,
        "transcript": "Atam tauna, ilamni-am uani uanlata, kiani-ll' taukut uika tua-i, kiani.",
        "translation": "You see, at that time, I would be with my family downriver since they were downriver and my spouse was upriver."
    },
    "421": {
        "startTime": 3703.7,
        "endTime": 3707.625,
        "transcript": "Kiugna village-arraq, iciw' piani avtaalriit.",
        "translation": "The village upriver, you know how they split inland."
    },
    "422": {
        "startTime": 3707.631,
        "endTime": 3713.619,
        "transcript": "Ilmanun anelrarqama meglartua, iciw' utercuumiinii.",
        "translation": "When I went downriver to my family, I wouldn't want to go back, you know, not want to go home."
    },
    "423": {
        "startTime": 3713.632,
        "endTime": 3717.094,
        "transcript": "Aanama pingnauraanga, \"Ampi uterten.\"",
        "translation": "My mother would start telling me, \"Go home already.\""
    },
    "424": {
        "startTime": 3717.42,
        "endTime": 3724.907,
        "transcript": "Tua-i taqsuq'ngaqama anlua, umyuaqa-w' tua-i Kass'at apqiitnek smash.",
        "translation": "I would go out when I got tired, and my mental state would be smashed as they say in English."
    },
    "425": {
        "startTime": 3724.92,
        "endTime": 3728.882,
        "transcript": "Itra'urlulalrianga taukunun uimnun.",
        "translation": "Pity me, I would go upriver to my husband's."
    },
    "426": {
        "startTime": 3728.895,
        "endTime": 3740.095,
        "transcript": "Iteryartuarnaurtua tang nepaitqapiarluni. Iternaurtua ak'a inertellrullinill'. Takaipaa-ll' wangni. Takaitellrullinivaa.",
        "translation": "I would start to go in and it would be dead silent. I'd go in and he'd already have gone to bad. I acted so improperly. I had so little proper conduct."
    },
    "427": {
        "startTime": 3740.327,
        "endTime": 3745.064,
        "transcript": "Tua-i-ll' tua-i nallunrilama waniw' aipaqa inangqiin",
        "translation": "Then since I knew that my spouse was laying here"
    },
    "428": {
        "startTime": 3745.077,
        "endTime": 3748.266,
        "transcript": "Canianun tua-i aklutuumarma inarr[lua].",
        "translation": "I'd lay next to him fully clothed."
    }
};